import React, { Component } from "react";
import VideoPlayer from "simple-react-video-thumbnail";
import VerticalTabs from "./dashboardTabsComponent";
import DescriptionIcon from "@mui/icons-material/Description";
import CloseIcon from "@material-ui/icons/Close";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SortIcon from "@mui/icons-material/Sort";
import HistoryIcon from "@mui/icons-material/History";
import EditIcon from "@mui/icons-material/Edit";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import ReplyIcon from "@mui/icons-material/Reply";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from "@mui/icons-material/Send";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import "../style/inventoryDetail.css";
import "../style/style.css";
import {
  Container,
  Grid,
  Typography,
  Button,
  Card,
  Paper,
  CardContent,
  FormControlLabel,
  Switch,
  FormGroup,
  List,
  ListItem,
  Tooltip,
  Modal,
  Box,
  FormControl,
  Select,
  MenuItem,
  IconButton,
} from "@material-ui/core";
import Header from "../../../../common/components/Header";
import Footer from "../../../../common/components/Footer";
import { inventoryDetailById } from "../actions/dashboardAction";
import searchinventry from "../actions/dashboardaapi";
import getActivepackage from "../actions/dashboardaapi";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import listingImg from "../../../../assests/images/Group-1863@2x.png";
import NewContentWrapper from "../../../../common/components/newContentWrapper";
import chrono from "../../../../assests/chrono24.png";
import ebay from "../../../../assests/ebay.png";
import pricelistImg from "../../../../assests/listprice.png";
import { Link } from "react-router-dom";
import { addChornoListing } from "../../dealer/actions/dealerAction";
import { toast } from "react-toastify";
import Swal from "sweetalert2/dist/sweetalert2.js";
import FbIcon from "../../../../assests/images/fb.png";
import { Alert, AlertTitle } from "@material-ui/lab";
import AddIcon from "../../../../../src/assests/images/add.png";
import defaulutImg from "../../../../assests/images/Bitmap.png";
import { AudioCard, VideoCard } from "material-ui-player";
import SlowMotionVideoIcon from "@material-ui/icons/SlowMotionVideo";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { SpinnerRoundFilled } from "spinners-react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BookmarkAddedIcon from "@mui/icons-material/BookmarkAdded";
import {
  getComponentActionList,
  isActionAllowed,
  getComponentViewsList,
  formatDate,
  renderInventoryStatusLabel,
  showErrorToast,
} from "../../../../common/components/Helper/Utils";
import { getCustomLabel } from "../../../../common/components/Helper/Utils";
import imageNotAvailable from "../../../../assests/images/img-soon.png";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Stack from "@mui/material/Stack";
import ViewInvoicemodel from "./ViewInvoicemodel";
import InventoryAuditLogsComponent from "./inventoryDetailAuditlog";
import pricelisticon from "../../../../assests/price-list.svg";
// const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
// const theme = useTheme();
var Loader = require("react-loader");
const FB = window.FB;

const getUsedGood = () => getCustomLabel("custom_used_good", "Used/Good");
const getMintVeryGood = () => getCustomLabel("custom_mint_verygood", "Mint/Very Good");
const getRetailReady = () => getCustomLabel("custom_retail_likenew", "Retail Ready/Like New");
const getNewCond = () => getCustomLabel("custom_new", "New");
const getUsed = () => getCustomLabel("custom_used", "Used");

const GALLERY_IMAGE_KEYS = [
  "front",
  "back",
  "left",
  "right",
  "free_form",
  "buckle_opened",
  "buckle_closed",
  "wrist_shot",
];
const GALLERY_VIDEO_EXTENSIONS = [
  "mp4",
  "webm",
  "ogg",
  "ogv",
  "mov",
  "mkv",
  "avi",
  "m4v",
  "3gp",
];

const getGalleryMediaExtension = (src = "") => {
  const clean = String(src).split("?")[0].split("#")[0];
  const idx = clean.lastIndexOf(".");
  return idx >= 0 ? clean.slice(idx + 1).toLowerCase() : "";
};

const isGalleryVideo = (key, src) =>
  /^video/i.test(String(key || "")) ||
  GALLERY_VIDEO_EXTENSIONS.includes(getGalleryMediaExtension(src));

const getGalleryPositionIndex = (key) => {
  const normalized = String(key || "").toLowerCase();
  const configuredIndex = GALLERY_IMAGE_KEYS.indexOf(normalized);
  if (configuredIndex !== -1) return configuredIndex;
  const preimageMatch = normalized.match(/^preimage(\d+)$/);
  if (preimageMatch) {
    return GALLERY_IMAGE_KEYS.length + Number(preimageMatch[1]) - 1;
  }
  return Number.MAX_SAFE_INTEGER;
};

const ClampedNoteValue = ({ text }) => {
  const wrapRef = React.useRef(null);
  const [overflow, setOverflow] = React.useState(false);
  const value = text ? text : "---";

  React.useLayoutEffect(() => {
    const el = wrapRef.current;
    if (!el) return;
    setOverflow(Boolean(text) && el.scrollHeight > el.clientHeight + 1);
  }, [text]);

  return (
    <Tooltip
      arrow
      placement="left"
      interactive
      disableHoverListener={!overflow}
      title={
        overflow ? (
          <span className="inv-note-tooltip-text">{text}</span>
        ) : (
          ""
        )
      }
    >
      <div
        ref={wrapRef}
        className={`inv-note-value ${overflow ? "has-overflow" : ""}`}
      >
        {value}
      </div>
    </Tooltip>
  );
};

const InventoryStatusLookup = {
  2: "Incoming",
  6: "Needs Service / Polish",
  7: "At Service",
  11: "Intake Complete",
  13: "Need to Post",
  12: "Invoiced",
  1: "Inhand",
  3: "Out on Memo",
  4: "On Hold / Reserved",
  8: "Need to Ship",
  9: "Shipped waiting on payment",
  10: "Sold & Cashed Out",
  5: "Available to Order",
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  maxHeight: 600,
  overflowY: "auto",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

class InventoryDetailComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      purchaseDate: "NewDate",
      purchaseDate1: "NewDate1",
      fullScreen: true,
      open: false,
      setOpen: false,
      inventoryDetailByIdDetails: [],
      isShopifyEnabled:
        window.sessionStorage.getItem("isShopifyEnabled") === "true",
      isShopifyVerified:
        window.sessionStorage.getItem("isShopifyVerified") === "true",
      isQboVerified: window.sessionStorage.getItem("isQboVerified") === "true",
      isEbayVerified: window.sessionStorage.getItem("isEbayVerified") === "true",
      productDetails: [],
      prodId: "",
      sold_price: "",
      displayUrl: false,
      manageResult: false,
      ChronoUrl: "",
      inventory_id: "",
      listed_on: "chrono",
      sold_status: "",
      enbleAltert: false,
      displaysharingImg: false,
      inventryPricelist: [],
      loaded: false,
      soldbtn: false,
      ebayAmout: "",
      croono21Ammount: "",
      retailAmount: "",
      listing_addon: false,
      accessData: [],
      viewData: [],
      auditLogs: [],
      viewInvoiceModal: false,
      invoiceViewType: null,
      openHistoryModal: false,
      invoiceId: !isNaN(localStorage.getItem("invoiceId"))
        ? localStorage.getItem("invoiceId")
        : null,
      userData: sessionStorage.getItem("userDetails")
        ? JSON.parse(sessionStorage.getItem("userDetails"))
        : null,
      openModal: false,
      invoiceType: "regular_invoice",
      qboitemid: null,
      openInvoiceModal: false,
      // uploadimages: ''
      wordHtmlMap: {},
      wordLoadingMap: {},
      galleryIndex: 0,
      galleryPreviewOpen: false,
      commentsOpen: true,
      commentText: "",
      replyToId: null,
      comments: [],
      commentsLoading: false,
      commentsSubmitting: false,
      commentMenuId: null,
      deleteCommentDialogOpen: false,
      deleteCommentId: null,
      deleteCommentSubmitting: false,
      commentSortOrder: "oldest",
      expandedReplyIds: {},
      additionalDetailsOpen: false,
      mentionUsers: [],
      mentionUsersLoading: false,
      mentionDropdownOpen: false,
      mentionQuery: "",
      mentionStartIndex: -1,
      mentionHighlightIndex: 0,
      pendingMentions: [],
      mentionField: "compose",
      editingCommentId: null,
      editCommentText: "",
      editCommentSubmitting: false,
    };
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.onsocialsearch1 = this.onsocialsearch1.bind(this);
    this.onsocialsearch2 = this.onsocialsearch2.bind(this);
    this.onsocialsearch3 = this.onsocialsearch3.bind(this);
    this.onsocialsearch4 = this.onsocialsearch4.bind(this);
    this.onsocialsearch5 = this.onsocialsearch5.bind(this);
    this.onsocialsearch6 = this.onsocialsearch6.bind(this);
    this.onsocialsearch7 = this.onsocialsearch7.bind(this);
    this.onsocialsearch8 = this.onsocialsearch8.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.onsocialsearch = this.onsocialsearch.bind(this);
    this.addChoonoListing = this.addChoonoListing.bind(this);
    this.changeRangeName = this.changeRangeName.bind(this);
    this.onclickfacebookshare = this.onclickfacebookshare.bind(this);
    // this.getproductDetails = this.getproductDetails.bind(this)
    this.editinvnetrydeatils = this.editinvnetrydeatils.bind(this);
    this.boxcheckboxselection = this.boxcheckboxselection.bind(this);
    this.editIconClick = this.editIconClick.bind(this);
    this.backNavigation = this.backNavigation.bind(this);
    this.handleClickBreadCrumbs = this.handleClickBreadCrumbs.bind(this);
    this.handleMyInventoryClick = this.handleMyInventoryClick.bind(this);
    this.handleClosecheck = this.handleClosecheck.bind(this);
    this.viewhistory = this.viewhistory.bind(this);
    this.commentInputRef = React.createRef();
    this.commentEditInputRef = React.createRef();
  }

  handleReplyToComment = (commentId) => {
    this.setState(
      {
        replyToId: commentId,
        commentText: "",
        commentMenuId: null,
        pendingMentions: [],
        mentionDropdownOpen: false,
        mentionQuery: "",
        mentionStartIndex: -1,
      },
      () => {
        const input = this.commentInputRef.current;
        if (!input) return;
        input.focus();
        input.scrollIntoView({ behavior: "smooth", block: "center" });
      },
    );
  };

  scrollInventoryDetailToTop = () => {
    window.scrollTo(0, 0);
    if (document.documentElement) document.documentElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;
  };

  componentDidMount() {
    this.scrollInventoryDetailToTop();
    const linkStyle = {
      fontSize: "14px",
      color: "black",
      backgroundColor: "white",
      textDecoration: "none",
      transition: "color 0.3s",
      cursor: "pointer",
    };

    const hoverStyle = {
      color: "#007bff",
      textDecoration: "underline",
    };
    const accessDataObject = getComponentActionList("inventory_details");
    const viewDataObject = getComponentViewsList("inventory_details");
    this.setState({ accessData: accessDataObject, viewData: viewDataObject });
    let productId = this.props.match.params.productId;
    let id = this.props.match.params.id;
    this.setState({
      inventory_id: id,
    });

    this.setState({
      ChronoUrl:
        "(Your Chrone24 xml url is URL(https://api.watchops.com/inventories/" +
        this.props.match.params.userId +
        "/c24-importer.xml))",
    });
    // this.props.inventoryDetailById(id);
    // const datagg = this.props.inventoryDetailById(id);
    searchinventry.getinventryDetails(id).then((res) => {
      if (res.data.success === 1) {
        if (
          res.data.data &&
          res.data.data.technical_details &&
          typeof res.data.data.technical_details === "string"
        ) {
          const technical_details = JSON.parse(res.data.data.technical_details);
          res.data.data.technical_details = technical_details;
        }
        if (
          res.data.data?.purchaseinvoiceimages &&
          typeof res.data.data.purchaseinvoiceimages === "string"
        ) {
          try {
            res.data.data.purchaseinvoiceimages = JSON.parse(
              res.data.data.purchaseinvoiceimages,
            );
          } catch (e) {
            // console.log("Failed to parse purchaseinvoiceimages", e);
          }
        }
        this.setState({
          inventoryDetailByIdDetails: res.data.data,
          prodId: res.data.data.productid,
          galleryIndex: 0,
          galleryPreviewOpen: false,
          },
          () => {
            this.scrollInventoryDetailToTop();
            setTimeout(() => this.scrollInventoryDetailToTop(), 100);
        },
);
        this.fetchInventoryComments(res.data.data?.inventoryid || id, {
          scrollToTop: true,
});
        // this.getproductDetails(this.state.prodId)
        if (this.state.prodId) {
          this.getpriceLsting(this.state.prodId);
        } else {
          this.setState({ loaded: true }, () => {
            this.scrollInventoryDetailToTop();
            setTimeout(() => this.scrollInventoryDetailToTop(), 50);
          });
        }
        this.boxcheckboxselection();
        // this.getActivePackages();
        searchinventry.getActivepackage().then((res) => {
          if (res.data.data && res.data.data.listing_addon) {
            this.setState({
              listing_addon: res.data.data.listing_addon,
            });
          }
        });
      } else {
        this.setState({
          inventoryDetailByIdDetails: res.data,
          manageResult: true,
          loaded: true,
        });
      }
    });
  }
  handleClosecheck() {
    this.setState({ viewInvoiceModal: false });
  }
  getpriceLsting(id) {
    searchinventry.getinventrypriceList(id).then((res) => {
      this.setState({
        inventryPricelist: res.data.data,
        loaded: true,
        },
        () => {
          this.scrollInventoryDetailToTop();
          setTimeout(() => this.scrollInventoryDetailToTop(), 50);
      },
);
      for (let i = 0; i < this.state.inventryPricelist.length; i++) {
        if (this.state.inventryPricelist[i].watch_source == "Chrono24") {
          this.setState({
            croono21Ammount: this.state.inventryPricelist[i].avg,
          });
        } else if (this.state.inventryPricelist[i].watch_source == "Retail") {
          this.setState({ retailAmount: this.state.inventryPricelist[i].avg });
        } else if (this.state.inventryPricelist[i].watch_source == "EBay") {
          this.setState({ ebayAmout: this.state.inventryPricelist[i].avg });
        }
      }
    });
  }
  handleOpenInvoice = () => {
    this.setState({ openInvoiceModal: true }, () => {
      const images =
        this.state.inventoryDetailByIdDetails?.purchaseinvoiceimages?.images ||
        [];
      images.forEach((img, index) => {
        const lower = img.toLowerCase();
        if (lower.includes(".doc") || lower.includes(".docx")) {
          this.loadMammothAndConvert(img, index);
        }
      });
    });
  };

  loadMammothAndConvert = (url, index) => {
    this.setState((prev) => ({
      wordLoadingMap: { ...prev.wordLoadingMap, [index]: true },
      wordHtmlMap: { ...prev.wordHtmlMap, [index]: "" },
    }));

    const loadMammoth = () => {
      return new Promise((resolve, reject) => {
        if (window.mammoth) {
          resolve(window.mammoth);
          return;
        }
        const script = document.createElement("script");
        script.src =
          "https://cdnjs.cloudflare.com/ajax/libs/mammoth/1.6.0/mammoth.browser.min.js";
        script.onload = () => resolve(window.mammoth);
        script.onerror = () => reject(new Error("Failed to load mammoth.js"));
        document.head.appendChild(script);
      });
    };

    fetch(url)
      .then((res) => res.arrayBuffer())
      .then((arrayBuffer) => {
        return loadMammoth().then((mammoth) =>
          mammoth.convertToHtml({ arrayBuffer }),
        );
      })
      .then((result) => {
        this.setState((prev) => ({
          wordHtmlMap: { ...prev.wordHtmlMap, [index]: result.value },
          wordLoadingMap: { ...prev.wordLoadingMap, [index]: false },
        }));
      })
      .catch(() => {
        this.setState((prev) => ({
          wordHtmlMap: {
            ...prev.wordHtmlMap,
            [index]: "<p style='color:red'>Failed to preview document.</p>",
          },
          wordLoadingMap: { ...prev.wordLoadingMap, [index]: false },
        }));
      });
  };

  handleCloseInvoice = () => {
    this.setState({ openInvoiceModal: false });
  };

  getActivePackages() {}

  handleClickBreadCrumbs(event) {
    event.preventDefault();
    console.info("You clicked a breadcrumb.");
  }

  handleMyInventoryClick() {
    const { history } = this.props;
    history.push("/myinventory");
    setTimeout(() => window.scrollTo(0, 0), 50);
  }
  // formatRange(min, max) {
  //     if (min == null && max == null) {
  //       return "N/A";
  //     }

  //     if (
  //       (min === 0 || min === "0" || isNaN(min)) &&
  //       (max === 0 || max === "0" || isNaN(max))
  //     ) {
  //       return "N/A";
  //     }

  //     const minVal = Number(min);
  //     const maxVal = Number(max);

  //     return `${!isNaN(minVal) ? `$${minVal}` : "—"} - ${
  //       !isNaN(maxVal) ? `$${maxVal}` : "—"
  //     }`;
  // }
  boxcheckboxselection() {
    if (this.state.inventoryDetailByIdDetails.sold == 1) {
      this.setState({
        soldbtn: true,
      });
    } else {
      this.setState({
        soldbtn: false,
      });
    }
  }

  onclickfacebookshare() {
    this.setState({
      displaysharingImg: true,
    });
  }
  onsocialsearch1(e) {
    this.setState({
      uploadimages: e,
      displaysharingImg: false,
    });
    this.onsocialsearch(e);
  }
  onsocialsearch2(e) {
    this.setState({
      uploadimages: e,
      displaysharingImg: false,
    });
    this.onsocialsearch(e);
  }
  onsocialsearch3(e) {
    this.setState({
      uploadimages: e,
      displaysharingImg: false,
    });
    this.onsocialsearch(e);
  }
  onsocialsearch4(e) {
    this.setState({
      uploadimages: e,
      displaysharingImg: false,
    });
    this.onsocialsearch(e);
  }
  onsocialsearch5(e) {
    this.setState({
      uploadimages: e,
      displaysharingImg: false,
    });
    this.onsocialsearch(e);
  }
  onsocialsearch6(e) {
    this.setState({
      uploadimages: e,
      displaysharingImg: false,
    });
    this.onsocialsearch(e);
  }
  onsocialsearch7(e) {
    this.setState({
      uploadimages: e,
      displaysharingImg: false,
    });
    this.onsocialsearch(e);
  }
  onsocialsearch8(e) {
    this.setState({
      uploadimages: e,
      displaysharingImg: false,
    });
    this.onsocialsearch(e);
  }
  onsocialsearch(uploadImages) {
    this.setState({
      uploadimages: uploadImages,
    });
    window.fbAsyncInit = function () {
      window.FB.getLoginStatus(({ authResponse }) => {});
    };
    FB.ui(
      {
        display: "popup",
        method: "feed",
        picture: uploadImages,
        link: uploadImages,
      },
      function (response) {},
    );
  }
  backNavigation() {
    const { history } = this.props;
    history.push("/myinventory");
    setTimeout(() => window.scrollTo(0, 0), 50);
  }

  addChoonoListing() {
    this.setState({ loaded: false });
    let data = {
      inventory_id: this.state.inventory_id,
      listed_on: "chrono",
    };
    addChornoListing(data, (error, res) => {
      if (res.data.success === 1) {
        toast(res.data.message, {
          autoClose: 5000,
          type: toast.TYPE.SUCCESS,
          position: toast.POSITION.BOTTOM_CENTER,
        });
        Swal.fire(
          this.state.ChronoUrl,
          " <br>Use this Xml link for further Usage",
        );
        this.setState({
          displayUrl: true,
          loaded: true,
        });
      } else {
        this.setState({
          displayUrl: true,
          loaded: true,
        });
        Swal.fire(
          this.state.ChronoUrl,
          " <br>Use this Xml link for further Usage",
        );
        toast(res.data.message, {
          autoClose: 5000,
          type: toast.TYPE.ERROR,
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    });
  }
  // getproductDetails (id){
  //     searchinventry.getProductsDetails(id).then((res) => {
  //         this.setState({
  //             productDetails: res.data.data
  //         })
  //     })
  // }
  // socialshare(e){
  //     console.log(e)
  // }
  viewhistory = () => {
    const inventoryId = this.state.inventoryDetailByIdDetails.inventoryid;
    this.setState({
      inventory_id: inventoryId,
      openHistoryModal: true,
    });
  };
  handleCloseHistory = () => {
    this.setState({ openHistoryModal: false, auditLogs: [] });
  };
  editinvnetrydeatils() {
    this.props.history.push(
      "/update-inventry-details/" +
        this.state.inventoryDetailByIdDetails.inventoryid,
      this.props.history.location.state,
    );
  }

  changeRangeName = (event) => {
    const checkstaus = event.target.checked;
    if (checkstaus === true) {
      this.setState({
        inventory_id: this.state.inventoryDetailByIdDetails.inventoryid,
        sold_status: "1",
        soldbtn: true,
      });
      localStorage.setItem("sold_status", "1");
    } else {
      this.setState({
        inventory_id: this.state.inventoryDetailByIdDetails.inventoryid,
        sold_status: "0",
        soldbtn: false,
      });
      localStorage.setItem("sold_status", "0");
    }
    let data = {
      inventory_id: this.state.inventory_id,
      sold_status: localStorage.getItem("sold_status"),
      listed_on: this.state.listed_on,
    };
    searchinventry.productsold(data).then((res) => {
      if (res.data.success === 1) {
        toast(res.data.message, {
          autoClose: 5000,
          type: toast.TYPE.SUCCESS,
          position: toast.POSITION.BOTTOM_CENTER,
        });
        localStorage.removeItem("sold_status");

        this.setState({
          enbleAltert: true,
        });
      } else {
        toast(res.data.message, {
          autoClose: 5000,
          type: toast.TYPE.ERROR,
          position: toast.POSITION.BOTTOM_CENTER,
        });
        localStorage.removeItem("sold_status");
        this.setState({
          enbleAltert: true,
        });
      }
    });
  };

  handleClickOpen() {
    this.setState({
      open: true,
      setOpen: true,
    });
  }

  handleClose() {
    this.setState({
      open: false,
      setOpen: false,
    });
  }

  editIconClick() {
    const { inventoryid } = this.state.inventoryDetailByIdDetails;
    this.props.history.push({
      pathname: "/update-inventry-images-details/" + inventoryid,
      state: { inventoryDetailPage: true },
    });
  }

  handleOpenModal = () => {
    this.setState({ openModal: true });
  };

  handleCloseModal = () => {
    this.setState({ openModal: false });
  };

  getInvoiceDetails = (inventoryDetailByIdDetails) => {
    const {
      type,
      serialno,
      purchaseprice,
      quantity,
      inventoryid,
      technical_details,
      invattr,
      imagepaths,
      product_imagepaths,
      sold_price,
      minmax_pricelist,
    } = inventoryDetailByIdDetails ?? {};

    const isMiscProductOrWatch =
      type === "misc_product" || type === "misc_watch";

    const model = isMiscProductOrWatch
      ? technical_details?.product_title ||
        technical_details?.product_name ||
        ""
      : invattr?.reference;

    const productid = isMiscProductOrWatch
      ? technical_details?.productid
      : inventoryDetailByIdDetails?.productid;

    const productName = isMiscProductOrWatch
      ? technical_details?.product_title ||
        technical_details?.product_name ||
        ""
      : null;

    const desc = isMiscProductOrWatch
      ? technical_details?.product_title ||
        technical_details?.product_name ||
        ""
      : inventoryDetailByIdDetails?.inventory_title || invattr?.model || "---";

    const image =
      imagepaths?.front ||
      imagepaths?.back ||
      imagepaths?.left ||
      imagepaths?.right ||
      imagepaths?.wrist_shot ||
      imagepaths?.buckle_closed ||
      imagepaths?.buckle_opened ||
      imagepaths?.free_form ||
      product_imagepaths?.images?.[0] ||
      imageNotAvailable;

    const soldprice = sold_price
      ? sold_price
      : inventoryDetailByIdDetails?.sold_price
        ? inventoryDetailByIdDetails.sold_price
        : null;
    return {
      model,
      serialno,
      productid,
      productName,
      purchaseprice,
      desc,
      type,
      quantity,
      inventoryid,
      image,
      soldprice,
    };
  };

  getCurrentUserId = () => {
    const user = this.state.userData || {};
    return user.userId ?? user.userid ?? user.id ?? user.user_id ?? null;
  };

  canDeleteAnyCommentByRole = () => {
    // Admin (2), Owner (3), Expert (6)
    const roleId = Number(this.state.userData?.roleId);
    return [2, 3, 6].includes(roleId);
  };

  getCommentAvatarInitials = (name) => {
    const parts = String(name || "")
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    if (!parts.length) return "U";
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
  };

  getProfilePicUrl = (pic) => {
    if (!pic) return null;
    const url = String(pic).replace(/^"|"$/g, "").trim();
    return url || null;
  };

  getCurrentUserProfilePic = () => {
    const user = this.state.userData || {};
    return this.getProfilePicUrl(
      user.profilePic || user.profilepic || user.profile_pic,
    );
  };

  getCommentProfilePic = (item) => {
    if (!item) return null;
    const direct = this.getProfilePicUrl(item.profilepic || item.profilePic);
    if (direct) return direct;

    const currentUserId = this.getCurrentUserId();
    if (
      currentUserId != null &&
      item.userId != null &&
      String(item.userId) === String(currentUserId)
    ) {
      const selfPic = this.getCurrentUserProfilePic();
      if (selfPic) return selfPic;
    }

    const match = (this.state.mentionUsers || []).find(
      (user) =>
        user.userId != null &&
        item.userId != null &&
        String(user.userId) === String(item.userId),
    );
    return this.getProfilePicUrl(match?.profilepic);
  };

  handleCommentAvatarError = (e) => {
    e.currentTarget.style.display = "none";
    const fallback = e.currentTarget.nextSibling;
    if (fallback) fallback.style.display = "flex";
  };

  renderCommentAvatar = ({
    name,
    profilepic,
    className = "inv-comment-avatar",
  } = {}) => {
    const pic = this.getProfilePicUrl(profilepic);
    return (
      <div className={className}>
        {pic ? (
          <img
            src={pic}
            alt=""
            className="inv-comment-avatar-img"
            onError={this.handleCommentAvatarError}
          />
        ) : null}
        <span
          className="inv-comment-avatar-initials"
          style={pic ? { display: "none" } : undefined}
        >
          {this.getCommentAvatarInitials(name)}
        </span>
      </div>
    );
  };

  sortCommentsByDate = (items, order = this.state.commentSortOrder) => {
    const list = [...(items || [])];
    list.sort((a, b) => {
      const aTime = a?.createdAt ? new Date(a.createdAt).getTime() : 0;
      const bTime = b?.createdAt ? new Date(b.createdAt).getTime() : 0;
      if (aTime !== bTime) {
        return order === "newest" ? bTime - aTime : aTime - bTime;
      }
      const aId = Number(a?.id) || 0;
      const bId = Number(b?.id) || 0;
      return order === "newest" ? bId - aId : aId - bId;
    });
    return list;
  };

  toggleCommentSortOrder = () => {
    this.setState((prev) => ({
      commentSortOrder: prev.commentSortOrder === "newest" ? "oldest" : "newest",
    }));
  };

  toggleRepliesExpanded = (commentId) => {
    this.setState((prev) => ({
      expandedReplyIds: {
        ...prev.expandedReplyIds,
        [commentId]: !prev.expandedReplyIds[commentId],
      },
    }));
  };

  getCurrentUserName = () => {
    const user = this.state.userData || {};
    const fullName = [
      user.firstName || user.firstname || user.first_name,
      user.lastName || user.lastname || user.last_name,
    ]
      .filter(Boolean)
      .join(" ")
      .trim();
    return (
      fullName ||
      user.userName ||
      user.username ||
      user.name ||
      user.accountName ||
      user.businessname ||
      "User"
    );
  };

  normalizeCommentItem = (item, parentId = null) => {
    if (!item) return null;
    const id = item.id ?? item.comment_id;
    const userId = item.user_id ?? item.userid ?? item.userId ?? null;
    const currentUserId = this.getCurrentUserId();
    const isOwnComment =
      currentUserId != null &&
          userId != null &&
          String(userId) === String(currentUserId);
    const canDelete =
      typeof item.can_delete === "boolean"
        ? item.can_delete || this.canDeleteAnyCommentByRole()
        : isOwnComment || this.canDeleteAnyCommentByRole();

    return {
      id,
      parentId: item.parent_id ?? item.parentId ?? parentId ?? null,
      userId,
      userName:
        item.user_name ||
        item.userName ||
        item.username ||
        [
          item.firstName || item.firstname || item.first_name,
          item.lastName || item.lastname || item.last_name,
        ]
          .filter(Boolean)
          .join(" ")
          .trim() ||
        item.accountName ||
        item.businessname ||
        "User",
      profilepic:
        item.profilepic || item.profilePic || item.profile_pic || null,
      text: item.text || item.comment || "",
      mentions: Array.isArray(item.mentions)
        ? item.mentions.map((mention) => ({
            userId: mention.user_id ?? mention.userid ?? mention.userId ?? null,
            name:
              mention.name ||
              mention.user_name ||
              mention.userName ||
              [
                mention.firstname || mention.firstName,
                mention.lastname || mention.lastName,
              ]
                .filter(Boolean)
                .join(" ")
                .trim() ||
              "User",
            profilepic: mention.profilepic || null,
          }))
        : [],
      createdAt: item.created_at || item.createdAt || item.created_date || null,
      editedAt: item.edited_at || item.editedAt || item.modifiedon || null,
      canEdit:
        typeof item.can_edit === "boolean" ? item.can_edit : isOwnComment,
      canDelete,
    };
  };

  normalizeCommentsResponse = (payload) => {
    const list = Array.isArray(payload)
      ? payload
      : Array.isArray(payload?.data)
        ? payload.data
        : Array.isArray(payload?.comments)
          ? payload.comments
          : [];

    const flat = [];
    list.forEach((item) => {
      const parent = this.normalizeCommentItem(item, null);
      if (!parent) return;
      // Nested replies from API
      if (Array.isArray(item.replies) && item.replies.length) {
        flat.push({ ...parent, parentId: null });
        item.replies.forEach((reply) => {
          const normalizedReply = this.normalizeCommentItem(reply, parent.id);
          if (normalizedReply) flat.push(normalizedReply);
        });
        return;
      }
      flat.push(parent);
    });
    return flat;
  };

  fetchInventoryComments = (inventoryId, { scrollToTop = false } = {}) => {
    const id =
      inventoryId ||
      this.state.inventoryDetailByIdDetails?.inventoryid ||
      this.state.inventory_id;
    if (!id) return;

    this.setState({ commentsLoading: true });
    this.fetchMentionUsers(id);
    searchinventry
      .getInventoryComments(id)
      .then((res) => {
        if (!res) {
          this.setState({ commentsLoading: false }, () => {
            if (scrollToTop) this.scrollInventoryDetailToTop();
});
          return;
        }
        if (res.data?.success === 0) {
          showErrorToast(res.data?.message || "Failed to load comments");
          this.setState({ comments: [], commentsLoading: false }, () => {
            if (scrollToTop) this.scrollInventoryDetailToTop();
});
          return;
        }
        const comments = this.normalizeCommentsResponse(res.data);
        this.setState({ comments, commentsLoading: false }, () => {
          if (!scrollToTop) return;
          // Keep header in view after comments render (avoid inheriting My Inventory scroll).
          this.scrollInventoryDetailToTop();
          setTimeout(() => this.scrollInventoryDetailToTop(), 50);
        });
      })
      .catch((error) => {
        showErrorToast(error);
        this.setState({ comments: [], commentsLoading: false }, () => {
          if (scrollToTop) this.scrollInventoryDetailToTop();
});
      });
  };

  getGalleryMedia = () => {
    const details = this.state.inventoryDetailByIdDetails || {};
    const paths = details.imagepaths || {};
    const items = [];
    const seen = new Set();

    const pushItem = (src, type) => {
      if (!src || typeof src !== "string" || seen.has(src)) return;
      seen.add(src);
      items.push({ src, type });
    };

    const pushFromKey = (key) => {
      const value = paths[key];
      if (!value) return;
      const urls = Array.isArray(value) ? value : [value];
      urls.forEach((src) => {
        pushItem(src, isGalleryVideo(key, src) ? "video" : "image");
      });
    };

    Object.keys(paths)
      .filter((key) => !/^video/i.test(key))
      .sort((a, b) => {
        const aIndex = getGalleryPositionIndex(a);
        const bIndex = getGalleryPositionIndex(b);
        if (aIndex !== bIndex) return aIndex - bIndex;
        return String(a).localeCompare(String(b), undefined, { numeric: true });
      })
      .forEach(pushFromKey);

    Object.keys(paths)
      .filter((key) => /^video/i.test(key))
      .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
      .forEach(pushFromKey);

    if (items.length) return items;

    const type = (details.type || "").toLowerCase();
    const isMisc = type === "misc_product" || type === "misc_watch";
    if (isMisc) return [];

    const catalog = details.product_imagepaths?.images;
    if (Array.isArray(catalog)) {
      catalog.filter(Boolean).forEach((src) => {
        pushItem(src, isGalleryVideo("", src) ? "video" : "image");
      });
      return items;
    }
    if (typeof catalog === "string" && catalog) {
      return [{ src: catalog, type: isGalleryVideo("", catalog) ? "video" : "image" }];
    }
    return [];
  };

  getInventoryTypeLabel = () => {
    const type = this.state.inventoryDetailByIdDetails?.inventorytype;
    if (type === "1") return "Regular Inventory";
    if (type === "2") return "Memo Inventory";
    if (type === "3") return "Partnership Inventory";
    if (type === "5") return "Consignment Inventory";
    if (type === "4") return "Trade Inventory";
    return "---";
  };

  getConditionLabel = () => {
    const details = this.state.inventoryDetailByIdDetails || {};
    const condition = Number(details.condition);
    if (details.type === "misc_product") {
      if (condition === 2) return getUsed();
      return getNewCond();
    }
    if (condition === 4) return getNewCond();
    if (condition === 3) return getRetailReady();
    if (condition === 2) return getMintVeryGood();
    return getUsedGood();
  };

  getPapersYesNo = () => {
    const details = this.state.inventoryDetailByIdDetails || {};
    return details.warrantypaper === "1" ||
      details.archive === 1 ||
      details.is_service
      ? "Yes"
      : "No";
  };

  getBoxYesNo = () =>
    this.state.inventoryDetailByIdDetails?.warrantybox === "1" ? "Yes" : "No";

  getStatusBadgeClass = (statusId) => {
    const status = String(statusId);
    if (["1", "5", "11"].includes(status)) return "inv-status-pill";
    if (["13", "2"].includes(status)) return "inv-status-pill gold";
    if (["10", "12"].includes(status)) return "inv-status-pill danger";
    if (["3", "4", "6", "7", "8", "9"].includes(status))
      return "inv-status-pill warn";
    return "inv-status-pill neutral";
  };

  formatMoney = (value) => {
    if (value === 0 || value === "0") return "$0";
    if (value == null || value === "") return "---";
    const numeric = Number(String(value).replace(/[^0-9.-]/g, ""));
    if (Number.isNaN(numeric)) return `$${value}`;
    return `$${numeric.toLocaleString()}`;
  };

  handleGalleryNav = (direction) => {
    const media = this.getGalleryMedia();
    if (!media.length) return;
    this.setState((prev) => {
      const next = prev.galleryIndex + direction;
      if (next < 0 || next >= media.length) return null;
      return { galleryIndex: next };
    });
  };

  fetchMentionUsers = (inventoryId) => {
    const id =
      inventoryId ||
      this.state.inventoryDetailByIdDetails?.inventoryid ||
      this.state.inventory_id;
    if (!id) return;

    this.setState({ mentionUsersLoading: true });
    searchinventry
      .getInventoryMentionUsers(id)
      .then((res) => {
        if (!res || res.data?.success === 0) {
          this.setState({ mentionUsers: [], mentionUsersLoading: false });
          return;
        }
        const list = Array.isArray(res.data?.data) ? res.data.data : [];
        const users = list.map((user) => ({
          userId: user.user_id ?? user.userid ?? user.userId ?? user.id,
          name:
            user.name ||
            [user.firstname, user.lastname].filter(Boolean).join(" ").trim() ||
            "User",
          firstname: user.firstname || null,
          lastname: user.lastname || null,
          profilepic: user.profilepic || null,
          email: user.email || user.emailid || null,
        }));
        this.setState({ mentionUsers: users, mentionUsersLoading: false });
      })
      .catch(() => {
        this.setState({ mentionUsers: [], mentionUsersLoading: false });
      });
  };

  getMentionAvatarInitials = (name) => {
    const parts = String(name || "")
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    if (!parts.length) return "U";
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return `${parts[0][0] || ""}${parts[1][0] || ""}`.toUpperCase();
  };

  getFilteredMentionUsers = () => {
    const query = String(this.state.mentionQuery || "")
      .trim()
      .toLowerCase();
    const users = this.state.mentionUsers || [];
    if (!query) return users;
    return users.filter((user) => {
      const name = String(user.name || "").toLowerCase();
      const first = String(user.firstname || "").toLowerCase();
      const last = String(user.lastname || "").toLowerCase();
      return (
        name.includes(query) ||
        first.includes(query) ||
        last.includes(query) ||
        `${first} ${last}`.trim().includes(query)
      );
    });
  };

  closeMentionDropdown = () => {
    this.setState({
      mentionDropdownOpen: false,
      mentionQuery: "",
      mentionStartIndex: -1,
      mentionHighlightIndex: 0,
    });
  };

  detectMentionTrigger = (text, cursorPos) => {
    const before = String(text || "").slice(0, cursorPos);
    const match = before.match(/(^|\s)@([A-Za-z0-9 .'-]*)$/);
    if (!match) return null;
    const query = match[2] || "";
    const startIndex = before.lastIndexOf("@");
    const mentionSegment = before.slice(startIndex);

    const pending = this.state.pendingMentions || [];
    for (let i = 0; i < pending.length; i += 1) {
      const name = String(pending[i]?.name || "").trim();
      if (!name) continue;
      const label = `@${name}`;
      if (
        mentionSegment === `${label} ` ||
        mentionSegment.startsWith(`${label} `) ||
        mentionSegment.startsWith(`${label}\n`)
      ) {
        return null;
      }
    }

    return { query, startIndex };
  };

  handleMentionableTextChange = (e, field = "commentText") => {
    const value = e.target.value;
    const cursorPos =
      e.target.selectionStart != null ? e.target.selectionStart : value.length;
    const trigger = this.detectMentionTrigger(value, cursorPos);

    this.setState((prev) => {
      const pendingMentions = (prev.pendingMentions || []).filter((mention) =>
        value.includes(`@${mention.name}`),
      );
      if (!trigger) {
        return {
          [field]: value,
          pendingMentions,
          mentionField: field === "editCommentText" ? "edit" : "compose",
          mentionDropdownOpen: false,
          mentionQuery: "",
          mentionStartIndex: -1,
          mentionHighlightIndex: 0,
        };
      }
      return {
        [field]: value,
        pendingMentions,
        mentionField: field === "editCommentText" ? "edit" : "compose",
        mentionDropdownOpen: true,
        mentionQuery: trigger.query,
        mentionStartIndex: trigger.startIndex,
        mentionHighlightIndex: 0,
      };
    });
  };

  handleCommentTextChange = (e) => {
    this.handleMentionableTextChange(e, "commentText");
  };

  handleEditCommentTextChange = (e) => {
    this.handleMentionableTextChange(e, "editCommentText");
  };

  insertMentionUser = (user) => {
    if (!user?.userId) return;
    const isEdit = this.state.mentionField === "edit";
    const field = isEdit ? "editCommentText" : "commentText";
    const text = this.state[field] || "";
    const start = this.state.mentionStartIndex;
    if (start < 0) return;

    const before = text.slice(0, start);
    const afterAt = text.slice(start + 1);
    const typedQuery = this.state.mentionQuery || "";
    const after = afterAt.startsWith(typedQuery)
      ? afterAt.slice(typedQuery.length)
      : afterAt;
    const mentionLabel = `@${user.name}`;
    const nextText = `${before}${mentionLabel} ${after.replace(/^\s*/, "")}`;
    const caret = (before + mentionLabel + " ").length;

    this.setState(
      (prev) => {
        const exists = (prev.pendingMentions || []).some(
          (item) => String(item.userId) === String(user.userId),
        );
        return {
          [field]: nextText,
          pendingMentions: exists
            ? prev.pendingMentions
            : [...(prev.pendingMentions || []), user],
          mentionDropdownOpen: false,
          mentionQuery: "",
          mentionStartIndex: -1,
          mentionHighlightIndex: 0,
        };
      },
      () => {
        const input = isEdit
          ? this.commentEditInputRef.current
          : this.commentInputRef.current;
        if (input) {
          input.focus();
          input.setSelectionRange(caret, caret);
        }
      },
    );
  };

  handleMentionKeyDown = (e) => {
    const filtered = this.getFilteredMentionUsers();
    if (!(this.state.mentionDropdownOpen && filtered.length > 0)) return false;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      this.setState((prev) => ({
        mentionHighlightIndex:
          (prev.mentionHighlightIndex + 1) % filtered.length,
      }));
      return true;
    }
    if (e.key === "ArrowUp") {
      e.preventDefault();
      this.setState((prev) => ({
        mentionHighlightIndex:
          (prev.mentionHighlightIndex - 1 + filtered.length) % filtered.length,
      }));
      return true;
    }
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      const selected =
        filtered[this.state.mentionHighlightIndex] || filtered[0];
      this.insertMentionUser(selected);
      return true;
    }
    if (e.key === "Escape") {
      e.preventDefault();
      this.closeMentionDropdown();
      return true;
    }
    return false;
  };

  handleCommentKeyDown = (e) => {
    if (this.handleMentionKeyDown(e)) return;
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      this.handleAddComment(this.state.replyToId);
    }
  };

  handleEditCommentKeyDown = (item, e) => {
    if (this.handleMentionKeyDown(e)) return;
    if (e.key === "Escape") {
      e.preventDefault();
      this.cancelEditComment();
    }
    if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) {
      e.preventDefault();
      this.saveEditComment(item.id);
    }
  };

  getMentionsForSubmit = (text) => {
    const content = String(text || "");
    const lower = content.toLowerCase();
    const seen = new Set();
    const mentions = [];

    const addMention = (user) => {
      const userId = user?.userId ?? user?.user_id;
      const name = user?.name;
      if (userId == null || !name) return;
      const key = String(userId);
      if (seen.has(key)) return;
      seen.add(key);
      mentions.push({ user_id: userId, name });
    };

    (this.state.pendingMentions || []).forEach((mention) => {
      if (content.includes(`@${mention.name}`)) addMention(mention);
    });

    const users = [...(this.state.mentionUsers || [])].sort(
      (a, b) => String(b.name || "").length - String(a.name || "").length,
    );
    users.forEach((user) => {
      const name = String(user.name || "").trim();
      if (!name) return;
      if (lower.includes(`@${name.toLowerCase()}`)) addMention(user);
    });

    return mentions;
  };

  getKnownMentionNames = (mentions = [], { includeDirectory = true } = {}) => {
    const names = [];
    const seen = new Set();
    const addName = (name) => {
      const trimmed = String(name || "").trim();
      if (!trimmed) return;
      const key = trimmed.toLowerCase();
      if (seen.has(key)) return;
      seen.add(key);
      names.push(trimmed);
    };
    (mentions || []).forEach((mention) => addName(mention?.name));
    if (includeDirectory) {
    (this.state.mentionUsers || []).forEach((user) => addName(user?.name));
    }
    (this.state.pendingMentions || []).forEach((user) => addName(user?.name));
    names.sort((a, b) => b.length - a.length);
    return names;
  };

  renderCommentText = (text, mentions = [], options = {}) => {
    const content = String(text || "");
    if (!content) return null;
    const names = this.getKnownMentionNames(mentions, options);
    if (!names.length) return content;

    const escaped = names.map((name) =>
      name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
    );
    const regex = new RegExp(`@(?:${escaped.join("|")})`, "gi");
    const nodes = [];
    let lastIndex = 0;
    let match;
    regex.lastIndex = 0;
    while ((match = regex.exec(content)) !== null) {
      if (match.index > lastIndex) {
        nodes.push(content.slice(lastIndex, match.index));
      }
      nodes.push(
        <span className="inv-comment-mention" key={`mention-${match.index}`}>
          {match[0]}
        </span>,
      );
      lastIndex = match.index + match[0].length;
      if (match[0].length === 0) regex.lastIndex += 1;
    }
    if (lastIndex < content.length) {
      nodes.push(content.slice(lastIndex));
    }
    return nodes.length ? nodes : content;
  };

  renderCommentComposerHighlight = (value) => {
    const content = String(value || "");
    if (!content) return "\u00a0";
    const text = content.endsWith("\n") ? `${content} ` : content;
    // Only highlight mentions the user already selected (not while typing the query)
    const highlighted = this.renderCommentText(text, this.state.pendingMentions || [], {
      includeDirectory: false,
    });
    return highlighted || text;
  };

  syncComposerHighlightScroll = (e) => {
    const highlight = e.currentTarget.previousElementSibling;
    if (!highlight) return;
    highlight.scrollTop = e.currentTarget.scrollTop;
    highlight.scrollLeft = e.currentTarget.scrollLeft;
  };

  renderCommentComposerField = ({
    inputRef,
    value,
    disabled,
    placeholder,
    onChange,
    onKeyDown,
    onBlur,
  }) => (
    <div className="inv-comment-composer">
      <div className="inv-comment-composer-highlight" aria-hidden="true">
        {this.renderCommentComposerHighlight(value)}
      </div>
      <textarea
        ref={inputRef}
        className="inv-comment-composer-input"
        rows={3}
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onScroll={this.syncComposerHighlightScroll}
        onBlur={onBlur}
        spellCheck={false}
        autoCorrect="off"
        autoCapitalize="off"
      />
    </div>
  );

  handleAddComment = (parentId = null) => {
    const text = (this.state.commentText || "").trim();
    if (!text || this.state.commentsSubmitting) return;

    const inventoryId =
      this.state.inventoryDetailByIdDetails?.inventoryid ||
      this.state.inventory_id;
    if (!inventoryId) {
      showErrorToast("Inventory not found");
      return;
    }

    // One-level replies only: parent must be a top-level comment
    if (parentId != null) {
      const parent = (this.state.comments || []).find(
        (item) => String(item.id) === String(parentId),
      );
      if (!parent || parent.parentId != null) {
        showErrorToast("You can only reply to top-level comments");
        return;
      }
    }

    const mentions = this.getMentionsForSubmit(text);

    this.setState({ commentsSubmitting: true });
    searchinventry
      .addInventoryComment(inventoryId, {
        text,
        parent_id: parentId == null ? null : parentId,
        mentions,
      })
      .then((res) => {
        if (!res) {
          this.setState({ commentsSubmitting: false });
          return;
        }
        if (res.data?.success === 0) {
          showErrorToast(res.data?.message || "Failed to post comment");
          this.setState({ commentsSubmitting: false });
          return;
        }

        const created = res.data?.data || res.data?.comment || null;
        const normalized = this.normalizeCommentItem(
          {
            ...(created || {}),
            text: created?.text || created?.comment || text,
            parent_id: created?.parent_id ?? created?.parentId ?? parentId,
            user_id:
              created?.user_id ?? created?.userId ?? this.getCurrentUserId(),
            user_name:
              created?.user_name ||
              created?.userName ||
              this.getCurrentUserName(),
            created_at:
              created?.created_at ||
              created?.createdAt ||
              new Date().toISOString(),
            can_delete: true,
            mentions: created?.mentions || mentions,
          },
          parentId,
        );

        this.setState((prev) => ({
          commentText: "",
          replyToId: null,
          commentsSubmitting: false,
          pendingMentions: [],
          mentionDropdownOpen: false,
          mentionQuery: "",
          mentionStartIndex: -1,
          comments: normalized
            ? [...(prev.comments || []), normalized]
            : prev.comments,
        }));
      })
      .catch((error) => {
        showErrorToast(error);
        this.setState({ commentsSubmitting: false });
      });
  };

  handleDeleteComment = (commentId) => {
    if (commentId == null) return;
    this.setState({
      commentMenuId: null,
      deleteCommentDialogOpen: true,
      deleteCommentId: commentId,
    });
  };

  closeDeleteCommentDialog = () => {
    if (this.state.deleteCommentSubmitting) return;
    this.setState({
      deleteCommentDialogOpen: false,
      deleteCommentId: null,
    });
  };

  startEditComment = (item) => {
    if (!item?.id || !item.canEdit) return;
    const pendingMentions = (item.mentions || [])
      .map((mention) => ({
        userId: mention.userId ?? mention.user_id,
        name: mention.name,
        email: mention.email || null,
        profilepic: mention.profilepic || null,
      }))
      .filter((mention) => mention.userId != null && mention.name);
    this.setState(
      {
        editingCommentId: item.id,
        editCommentText: item.text || "",
        editCommentSubmitting: false,
        commentMenuId: null,
        replyToId: null,
        mentionField: "edit",
        pendingMentions,
        mentionDropdownOpen: false,
        mentionQuery: "",
        mentionStartIndex: -1,
        mentionHighlightIndex: 0,
      },
      () => {
        const input = this.commentEditInputRef.current;
        if (!input) return;
        input.focus();
        const len = input.value.length;
        input.setSelectionRange(len, len);
      },
    );
  };

  cancelEditComment = () => {
    if (this.state.editCommentSubmitting) return;
    this.setState({
      editingCommentId: null,
      editCommentText: "",
      mentionField: "compose",
      mentionDropdownOpen: false,
      mentionQuery: "",
      mentionStartIndex: -1,
      mentionHighlightIndex: 0,
    });
  };

  saveEditComment = (commentId) => {
    const text = (this.state.editCommentText || "").trim();
    if (!text || this.state.editCommentSubmitting) return;

    const inventoryId =
      this.state.inventoryDetailByIdDetails?.inventoryid ||
      this.state.inventory_id;
    if (!inventoryId) {
      showErrorToast("Inventory not found");
      return;
    }

    const mentions = this.getMentionsForSubmit(text);
    this.setState({ editCommentSubmitting: true });
    searchinventry
      .updateInventoryComment(inventoryId, commentId, { text, mentions })
      .then((res) => {
        if (!res) {
          this.setState({ editCommentSubmitting: false });
          return;
        }
        if (res.data?.success === 0) {
          showErrorToast(res.data?.message || "Failed to update comment");
          this.setState({ editCommentSubmitting: false });
          return;
        }

        const updated = this.normalizeCommentItem(
          res.data?.data || { id: commentId, text },
        );
        this.setState((prev) => ({
          editCommentSubmitting: false,
          editingCommentId: null,
          editCommentText: "",
          mentionField: "compose",
          mentionDropdownOpen: false,
          mentionQuery: "",
          mentionStartIndex: -1,
          comments: (prev.comments || []).map((item) => {
            if (String(item.id) !== String(commentId) || !updated) return item;
            return {
              ...item,
              ...updated,
              parentId: item.parentId,
              canDelete: item.canDelete,
            };
          }),
        }));
      })
      .catch((error) => {
        showErrorToast(error);
        this.setState({ editCommentSubmitting: false });
      });
  };

  renderCommentTimestamp = (item) => {
    const displayTime = item.editedAt || item.createdAt;
    return (
      <>
        <span className="inv-comment-time">
          {displayTime
            ? formatDate(displayTime, "MMM D, YYYY hh:mm A", false)
            : ""}
        </span>
        {item.editedAt ? (
          <span className="inv-comment-edited">· Edited</span>
        ) : null}
      </>
    );
  };

  renderMentionDropdown = () => {
    const filteredMentions = this.getFilteredMentionUsers();
    const showMentionDropdown =
      this.state.mentionDropdownOpen &&
      (filteredMentions.length > 0 || this.state.mentionUsersLoading);
    if (!showMentionDropdown) return null;

    return (
      <div className="inv-mention-dropdown" role="listbox">
        {this.state.mentionUsersLoading && filteredMentions.length === 0 ? (
          <div className="inv-mention-empty">Loading people...</div>
        ) : filteredMentions.length === 0 ? (
          <div className="inv-mention-empty">No users found</div>
        ) : (
          filteredMentions.map((user, index) => (
            <button
              type="button"
              key={user.userId}
              className={`inv-mention-option${
                index === this.state.mentionHighlightIndex ? " is-active" : ""
              }`}
              onMouseDown={(e) => {
                e.preventDefault();
                this.insertMentionUser(user);
              }}
            >
              {user.profilepic ? (
                <img
                  src={String(user.profilepic).replace(/^"|"$/g, "")}
                  alt=""
                  className="inv-mention-avatar-img"
                />
              ) : (
                <span className="inv-mention-avatar">
                  {this.getMentionAvatarInitials(user.name)}
                </span>
              )}
              <span className="inv-mention-meta">
                <span className="inv-mention-name">{user.name}</span>
                {user.email ? (
                  <span className="inv-mention-email">{user.email}</span>
                ) : null}
              </span>
            </button>
          ))
        )}
      </div>
    );
  };

  renderCommentEditForm = (item) => (
    <div className="inv-comment-edit">
      <div className="inv-comment-edit-wrap">
        {this.renderCommentComposerField({
          inputRef: this.commentEditInputRef,
          value: this.state.editCommentText,
          disabled: this.state.editCommentSubmitting,
          placeholder: "Write a comment...",
          onChange: this.handleEditCommentTextChange,
          onKeyDown: (e) => this.handleEditCommentKeyDown(item, e),
          onBlur: () => {
            setTimeout(() => this.closeMentionDropdown(), 150);
          },
        })}
        {this.state.mentionField === "edit" ? this.renderMentionDropdown() : null}
      </div>
      <div className="inv-comment-edit-tip">Tip: Press @ to mention people</div>
      <div className="inv-comment-edit-actions">
        <button
          type="button"
          className="inv-comment-edit-cancel"
          disabled={this.state.editCommentSubmitting}
          onClick={this.cancelEditComment}
        >
          Cancel
        </button>
        <button
          type="button"
          className="inv-comment-edit-save"
          disabled={
            this.state.editCommentSubmitting ||
            !(this.state.editCommentText || "").trim()
          }
          onClick={() => this.saveEditComment(item.id)}
        >
          {this.state.editCommentSubmitting ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );

  confirmDeleteComment = () => {
    const commentId = this.state.deleteCommentId;
    const inventoryId =
      this.state.inventoryDetailByIdDetails?.inventoryid ||
      this.state.inventory_id;
    if (!inventoryId || commentId == null || this.state.deleteCommentSubmitting) {
      return;
    }

    this.setState({ deleteCommentSubmitting: true });
    searchinventry
      .deleteInventoryComment(inventoryId, commentId)
      .then((res) => {
        if (!res) {
          this.setState({ deleteCommentSubmitting: false });
          return;
        }
        if (res.data?.success === 0) {
          showErrorToast(res.data?.message || "Failed to delete comment");
          this.setState({ deleteCommentSubmitting: false });
          return;
        }
        this.setState((prev) => ({
          deleteCommentDialogOpen: false,
          deleteCommentId: null,
          deleteCommentSubmitting: false,
          replyToId:
            String(prev.replyToId) === String(commentId)
              ? null
              : prev.replyToId,
        }));
        this.fetchInventoryComments(inventoryId);
      })
      .catch((error) => {
        showErrorToast(error);
        this.setState({ deleteCommentSubmitting: false });
      });
  };

  renderCommentActions = (item, { showReply = false } = {}) => {
    if (!showReply && !item?.canDelete && !item?.canEdit) return null;
    const isOpen = String(this.state.commentMenuId) === String(item?.id);
    return (
      <div className={`inv-comment-menu-wrap${isOpen ? " is-open" : ""}`}>
        <button
          type="button"
          className="inv-comment-menu-btn"
          aria-label="More actions"
          onClick={(e) => {
            e.stopPropagation();
            this.setState({ commentMenuId: isOpen ? null : item.id });
          }}
        >
          <MoreVertIcon className="inv-comment-menu" />
        </button>
        {isOpen && (
          <div
            className="inv-comment-menu-dropdown"
            onClick={(e) => e.stopPropagation()}
          >
            {showReply && (
              <button
                type="button"
                className="inv-comment-menu-item"
                onClick={() => {
                  this.setState({ commentMenuId: null });
                  this.handleReplyToComment(item.id);
                }}
              >
                <ReplyIcon fontSize="small" />
                Reply
              </button>
            )}
            {item?.canEdit && (
              <button
                type="button"
                className="inv-comment-menu-item"
                onClick={() => {
                  this.setState({ commentMenuId: null });
                  this.startEditComment(item);
                }}
              >
                <EditIcon fontSize="small" />
                Edit
              </button>
            )}
            {item?.canDelete && (
              <button
                type="button"
                className="inv-comment-menu-item danger"
                onClick={() => {
                  this.setState({ commentMenuId: null });
                  this.handleDeleteComment(item.id);
                }}
              >
                <DeleteIcon fontSize="small" />
                Delete
              </button>
            )}
          </div>
        )}
      </div>
    );
  };

  renderGallery = () => {
    const media = this.getGalleryMedia();
    const type = (
      this.state.inventoryDetailByIdDetails?.type || ""
    ).toLowerCase();
    const isMisc = type === "misc_product" || type === "misc_watch";
    const hasMedia = media.length > 0;
    const currentIndex = Math.min(
      this.state.galleryIndex,
      Math.max(media.length - 1, 0),
    );
    const currentItem = hasMedia
      ? media[currentIndex]
      : {
          src: isMisc ? imageNotAvailable : defaulutImg,
          type: "image",
        };
    const renderThumb = (item, index, keyPrefix) => (
      <button
        type="button"
        key={`${keyPrefix}-${item.src}-${index}`}
        className={`inv-gallery-thumb ${
          item.type === "video" ? "is-video" : ""
        } ${currentIndex === index ? "active" : ""}`}
        onClick={() => this.setState({ galleryIndex: index })}
      >
        {item.type === "video" ? (
          <>
            <video src={item.src} muted playsInline preload="metadata" />
            <span className="inv-gallery-thumb-play">
              <PlayCircleOutlineIcon fontSize="small" />
            </span>
          </>
        ) : (
          <img src={item.src} alt={`thumb-${index + 1}`} />
        )}
      </button>
    );
    const renderMainMedia = (item, alt) =>
      item.type === "video" ? (
        <video
          key={item.src}
          src={item.src}
          controls
          playsInline
          preload="metadata"
        />
      ) : (
        <img src={item.src} alt={alt} />
      );

    return (
      <div className="inv-gallery">
        {media.length > 1 && (
          <div className="inv-gallery-thumbs">
            {media.map((item, index) => renderThumb(item, index, "thumb"))}
          </div>
        )}
        <div
          className={`inv-gallery-main ${!hasMedia ? "is-default" : ""} ${
            !hasMedia && isMisc ? "is-placeholder" : ""
          } ${currentItem.type === "video" ? "is-video" : ""}`}
        >
          {media.length > 1 && (
            <button
              type="button"
              className="inv-gallery-nav prev"
              disabled={currentIndex === 0}
              onClick={() => this.handleGalleryNav(-1)}
            >
              <ChevronLeftIcon />
            </button>
          )}
          {renderMainMedia(currentItem, "inventory")}
          {media.length > 1 && (
            <button
              type="button"
              className="inv-gallery-nav next"
              disabled={currentIndex === media.length - 1}
              onClick={() => this.handleGalleryNav(1)}
            >
              <ChevronRightIcon />
            </button>
          )}
          {hasMedia && (
            <button
              type="button"
              className="inv-gallery-zoom"
              aria-label="Preview media"
              onClick={() => this.setState({ galleryPreviewOpen: true })}
            >
              <ZoomInIcon fontSize="small" />
            </button>
          )}
          {hasMedia && (
            <span className="inv-gallery-count">
              {currentIndex + 1} / {media.length}
            </span>
          )}
        </div>
        {hasMedia && (
          <Dialog
            open={!!this.state.galleryPreviewOpen}
            onClose={() => this.setState({ galleryPreviewOpen: false })}
            maxWidth="md"
            fullWidth
            className="inv-gallery-preview-dialog"
          >
            <div className="inv-gallery-preview">
              <button
                type="button"
                className="inv-gallery-preview-close"
                aria-label="Close preview"
                onClick={() => this.setState({ galleryPreviewOpen: false })}
              >
                <CloseIcon />
              </button>
              <div
                className={`inv-gallery-preview-main ${
                  currentItem.type === "video" ? "is-video" : ""
                }`}
              >
                {media.length > 1 && (
                  <button
                    type="button"
                    className="inv-gallery-nav prev"
                    disabled={currentIndex === 0}
                    onClick={() => this.handleGalleryNav(-1)}
                  >
                    <ChevronLeftIcon />
                  </button>
                )}
                {renderMainMedia(currentItem, "inventory preview")}
                {media.length > 1 && (
                  <button
                    type="button"
                    className="inv-gallery-nav next"
                    disabled={currentIndex === media.length - 1}
                    onClick={() => this.handleGalleryNav(1)}
                  >
                    <ChevronRightIcon />
                  </button>
                )}
              </div>
              {media.length > 1 && (
                <div className="inv-gallery-preview-thumbs">
                  {media.map((item, index) =>
                    renderThumb(item, index, "preview-thumb"),
                  )}
                </div>
              )}
            </div>
          </Dialog>
        )}
      </div>
    );
  };

  renderCommentInput = ({ isReply = false, replyParent = null,
    placement = "bottom", } = {}) => {
    return (
      <div
        className={`inv-comment-input-row${
          placement === "top" ? " inv-comment-input-row--top" : ""}`}
      >
        {this.renderCommentAvatar({
          name: this.getCurrentUserName(),
          profilepic: this.getCurrentUserProfilePic(),
          className: "inv-comment-avatar inv-comment-avatar--self",
        })}
        <div className="inv-comment-input-col">
          <div className="inv-comment-input-line">
            <div
              className={`inv-comment-input-wrap${isReply ? " is-replying" : ""}`}
            >
              {this.renderCommentComposerField({
                inputRef: this.commentInputRef,
                value: this.state.commentText,
                disabled: this.state.commentsSubmitting,
                placeholder: isReply
                  ? "Write a reply..."
                  : "Write a comment...",
                onChange: this.handleCommentTextChange,
                onKeyDown: this.handleCommentKeyDown,
                onBlur: () => {
                  setTimeout(() => this.closeMentionDropdown(), 150);
                },
              })}
              {this.state.mentionField !== "edit"
                ? this.renderMentionDropdown()
                : null}
            </div>
            <button
              type="button"
              className="inv-comment-send-btn"
              disabled={this.state.commentsSubmitting}
              onClick={() => this.handleAddComment(this.state.replyToId)}
            >
              <SendIcon fontSize="small" />
              Send
            </button>
          </div>
          <div className="inv-comment-input-tip">
            Tip: Press @ to mention people
          </div>
        </div>
      </div>
    );
  };

  renderComments = () => {
    const comments = this.state.comments || [];
    const topLevel = this.sortCommentsByDate(
      comments.filter((item) => item.parentId == null || item.parentId === ""),
    );
    const replyParent = this.state.replyToId
      ? comments.find((item) => String(item.id) === String(this.state.replyToId),)
      : null;
    const isReplying = !!this.state.replyToId && !!replyParent;
    const sortLabel =
      this.state.commentSortOrder === "newest" ? "Newest first" : "Oldest first";

    return (
      <>
      <Card className="inv-comments-card" elevation={0}
        onClick={() => {
          if (this.state.commentMenuId != null) {
            this.setState({ commentMenuId: null });
          }
        }}
      >
        <button
          type="button"
          className="inv-comments-header"
          onClick={() =>
            this.setState({ commentsOpen: !this.state.commentsOpen })
          }
        >
          <h3>
            <ChatBubbleOutlineIcon className="inv-comments-title-icon" />
            Comments ({topLevel.length})
          </h3>
          <div className="inv-comments-header-actions">
            {this.state.commentsOpen && topLevel.length > 0 && (
              <button
                type="button"
                className="inv-comments-sort-btn"
                aria-label={`Sort comments: ${sortLabel}`}
                onClick={(e) => {
                  e.stopPropagation();
                  this.toggleCommentSortOrder();
                }}
              >
                <SortIcon className="inv-comments-sort-icon" />
                {sortLabel}
              </button>
            )}
            <ExpandMoreIcon
              className={`inv-comments-chevron ${
                this.state.commentsOpen ? "open" : ""
              }`}
            />
          </div>
        </button>
        {this.state.commentsOpen && (
          <>
            {!isReplying &&
              this.state.commentSortOrder === "newest" &&
              this.renderCommentInput({ placement: "top" })}
            {this.state.commentsLoading ? (
              <div className="inv-comments-loading">Loading comments...</div>
            ) : topLevel.length === 0 ? (
              <div className="inv-comments-empty">No comments yet</div>
            ) : (topLevel.map((comment) => {
              const replies = this.sortCommentsByDate(
                comments.filter(
                  (item) => String(item.parentId) === String(comment.id),
                ),
              );
              const isReplyingToThis =
                isReplying &&
                String(this.state.replyToId) === String(comment.id);
              const repliesExpanded = !!this.state.expandedReplyIds[comment.id];
                return (
                <div
                  className={`inv-comment-item${
                    String(this.state.commentMenuId) === String(comment.id)
                      ? " is-menu-open"
                      : ""
                  }`}
                  key={comment.id}
                >
                  {this.renderCommentAvatar({
                    name: comment.userName,
                    profilepic: this.getCommentProfilePic(comment),
                  })}
                  <div className="inv-comment-body">
                    <div className="inv-comment-top">
                      <div className="inv-comment-meta">
                        <span className="inv-comment-name">
                          {comment.userName}
                        </span>
                        {this.renderCommentTimestamp(comment)}
                      </div>
                      {String(this.state.editingCommentId) !==
                        String(comment.id) &&
                        this.renderCommentActions(comment, { showReply: true })}
                    </div>
                    {String(this.state.editingCommentId) ===
                    String(comment.id)
                      ? this.renderCommentEditForm(comment)
                      : (
                    <div className="inv-comment-text">
                      {this.renderCommentText(comment.text, comment.mentions,)}
                    </div>
                      )}
                    {replies.length > 0 && (
                      <>
                        <button
                          type="button"
                          className="inv-comment-replies-toggle"
                          onClick={() =>
                            this.toggleRepliesExpanded(comment.id)
                          }
                        >
                          <ExpandMoreIcon
                            className={`inv-comment-replies-toggle-icon ${
                              repliesExpanded ? "open" : ""
                            }`}
                          />
                          {replies.length}{" "}
                          {replies.length === 1 ? "reply" : "replies"}
                        </button>
                        {repliesExpanded && (
                          <div className="inv-comment-replies">
                            {replies.map((reply) => {
                         return (
                              <div
                                className={`inv-comment-item${
                                  String(this.state.commentMenuId) ===
                                  String(reply.id)
                                    ? " is-menu-open"
                                    : ""
                                }`}
                                key={reply.id}
                              >
                                {this.renderCommentAvatar({
                                  name: reply.userName,
                                  profilepic: this.getCommentProfilePic(reply),
                                })}
                                <div className="inv-comment-body">
                                  <div className="inv-comment-top">
                                    <div className="inv-comment-meta">
                                      <span className="inv-comment-name">
                                        {reply.userName}
                                      </span>
                                      {this.renderCommentTimestamp(reply)}
                                    </div>
                                    {String(this.state.editingCommentId) !==
                                      String(reply.id) &&
                                      this.renderCommentActions(reply)}
                                  </div>
                                  {String(this.state.editingCommentId) ===
                                  String(reply.id)
                                    ? this.renderCommentEditForm(reply)
                                    : (
                                  <div className="inv-comment-text">
                                    {this.renderCommentText(
                                      reply.text,
                                      reply.mentions,
                                    )}
                                  </div>
                                    )}
                                </div>
                              </div>
                            );})}
                          </div>
                        )}
                      </>
                    )}
                    {isReplyingToThis && (
                      <div className="inv-comment-inline-reply">
                        <div className="inv-comment-replying">
                          {this.renderCommentAvatar({
                            name: replyParent.userName,
                            profilepic: this.getCommentProfilePic(replyParent),
                            className: "inv-comment-replying-avatar",
                          })}
                          <span className="inv-comment-replying-text">
                            Replying to {replyParent.userName}
                          </span>
                          <button
                            type="button"
                            className="inv-comment-replying-cancel"
                            onClick={() =>
                              this.setState({
                                replyToId: null,
                                commentText: "",
                                pendingMentions: [],
                                mentionDropdownOpen: false,
                                mentionQuery: "",
                                mentionStartIndex: -1,
                              })
                            }
                          >
                            Cancel
                          </button>
                        </div>
                        {this.renderCommentInput({
                          isReply: true,
                          replyParent,
                        })}
                      </div>
                    )}
                  </div>
                </div>
              );
              })
            )}
            {!isReplying &&
              this.state.commentSortOrder !== "newest" && this.renderCommentInput()}
          </>
        )}
      </Card>
        <Dialog
          open={!!this.state.deleteCommentDialogOpen}
          onClose={this.closeDeleteCommentDialog}
          className="inv-comment-delete-dialog"
          PaperProps={{ className: "inv-comment-delete-paper" }}
          aria-labelledby="inv-comment-delete-title"
        >
          <DialogTitle
            id="inv-comment-delete-title"
            className="inv-comment-delete-title"
            disableTypography
          >
            <Typography variant="h6" component="h2">
              Delete
            </Typography>
            <IconButton
              aria-label="close"
              className="inv-comment-delete-close"
              onClick={this.closeDeleteCommentDialog}
              disabled={this.state.deleteCommentSubmitting}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </DialogTitle>
          <DialogContent className="inv-comment-delete-content">
            <DialogContentText className="inv-comment-delete-text">
              Are you sure you want to <b>Delete</b>?
            </DialogContentText>
          </DialogContent>
          <DialogActions className="inv-comment-delete-actions">
            <Button
              onClick={this.closeDeleteCommentDialog}
              color="primary"
              disabled={this.state.deleteCommentSubmitting}
            >
              CANCEL
            </Button>
            <Button
              onClick={this.confirmDeleteComment}
              color="primary"
              disabled={this.state.deleteCommentSubmitting}
              autoFocus
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  };

  newContentView() {
    const { openModal, invoiceType } = this.state;
    let inventoryDetailByIdInfo = "";
    let id = "";
    let inventoryDetailByIdDetails = "";
    // if(this.props.inventoryDetailByIdInfo.success == 0){
    //     inventoryDetailByIdInfo = this.props.inventoryDetailByIdInfo;
    // }else{
    //     inventoryDetailByIdInfo = this.props.inventoryDetailByIdInfo.data;
    //      id = inventoryDetailByIdInfo.id;
    //      inventoryDetailByIdDetails = (inventoryDetailByIdInfo && inventoryDetailByIdInfo.prodattr) ? inventoryDetailByIdInfo.prodattr : "";
    // }
    // const minmax_pricelist =
    //   this.state.inventoryDetailByIdDetails?.minmax_pricelist;
    // const purchaseRange = this.formatRange(
    //   minmax_pricelist?.min_inventory_cost,
    //   minmax_pricelist?.max_inventory_cost
    // );
    // const sellingRange = this.formatRange(
    //   minmax_pricelist?.min_invoice_cost,
    //   minmax_pricelist?.max_invoice_cost
    // );
    const { warrantypaper, archive, is_service } =
      this.state.inventoryDetailByIdDetails;
    if (this.state.manageResult) {
      return (
        <div
          style={{
            marginLeft: "400px",
            marginTop: "50px",
            textAlign: "center",
          }}
        >
          <Card style={{ width: "600px", textAlign: "center" }}>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                <div> {this.state.inventoryDetailByIdDetails.message}</div>
              </Typography>
            </CardContent>
          </Card>
        </div>
      );
    } else {
      return (
        <div className="inv-detail-page">
          <link rel="icon" href="./faviconw.png" />

          {this.state.loaded == false ? (
            <div class="d-spinner">
              <SpinnerRoundFilled
                size={51}
                thickness={125}
                speed={80}
                color="rgba(57, 107, 172, 1)"
                className="spp"
                enabled={this.state.loaded == false}
              />
            </div>
          ) : (
            <div>
              <div>
                <Container style={{ marginBottom: "10px" }}>
                  <Grid
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    {/* <Grid>
                      <ArrowBackIcon
                        style={{
                          color: "action",
                          paddingRight: "15px",
                          marginTop: '5px',
                          fontSize: 40,
                          cursor: "pointer",
                        }}
                        onClick={this.backNavigation}
                      >

                      </ArrowBackIcon>
                    </Grid> */}
                    <Grid style={{ marginTop: 0 }}>
                      {/* <Typography  variant="h5"
                        className="font-size-18"><b>Go Back</b></Typography> */}

                      <div className="inv-detail-breadcrumb" onClick={this.handleClickBreadCrumbs}>
                        <Stack spacing={1}>
                          <Breadcrumbs
                            aria-label="breadcrumb"
                            separator={<span className="sperator">›</span>}
                          >
                            <Link
                              className="link"
                              style={{
                                fontSize: "14px",
                                color: "#CEA05F",
                                textDecoration: "underline !important",
                                backgroundColor: "white",
                              }}
                              to={{
                                pathname: "/myinventory",
                                state: { ...this.props.history.location.state },
                              }}
                            >
                              My Inventory
                            </Link>

                            <Link
                              className="inv-crumb-current"
                              aria-current="page"
                            >
                              Inventory Details
                            </Link>
                          </Breadcrumbs>
                        </Stack>
                      </div>
                    </Grid>
                  </Grid>
                  <Card className="inv-hero-card" elevation={0}>
                    <div className="inv-hero-top">
                      {this.renderGallery()}
                      <div className="inv-hero-right">
                      <div className="inv-hero-info">
                        <Typography className="inv-hero-title">
                          <span className="inv-hero-title-label">
                            Inventory Product Details
                          </span>
                          {(() => {
                            const details =
                              this.state.inventoryDetailByIdDetails || {};
                            const isMiscType = ["misc_watch", "misc_product"].includes(
                              (details.type || "").toLowerCase(),
                            );
                            const title = isMiscType
                              ? details.technical_details?.product_title ||
                                details.technical_details?.product_name ||
                                details.product_title ||
                                details.inventory_title ||
                                details.invattr?.model ||
                                ""
                              : details.inventory_title ||
                                details.technical_details?.product_title ||
                                details.technical_details?.product_name ||
                                details.invattr?.model ||
                                "";
                            if (!title) return null;
                            return (
                              <span className="inv-hero-title-product">
                                {title}
                              </span>
                            );
                          })()}
                        </Typography>
                        <div className="inv-hero-price-group">
                        {!["misc_watch", "misc_product"].includes(
                          (
                            this.state.inventoryDetailByIdDetails?.type || ""
                          ).toLowerCase(),
                        ) && (
                          <div className="inv-hero-price-row">
                            <DescriptionOutlinedIcon className="inv-hero-price-icon" />
                            <div className="inv-hero-price-text">
                            <Typography className="inv-hero-price-label">
                              Last Updated <span>MSRP</span>{" "}
                              {(() => {
                                const { lastupdatedate } =
                                  this.state.inventoryDetailByIdDetails || {};
                                if (
                                  !lastupdatedate ||
                                  isNaN(new Date(lastupdatedate))
                                ) {
                                  return <span className="msrp-asper">NA</span>;
                                }
                                const dateObj = new Date(lastupdatedate);
                                const month = dateObj.toLocaleString("en-US", {
                                  month: "short",
                                });
                                const year = dateObj.getFullYear();
                                return (
                                  <span className="msrp-asper">
                                    (As per {month}, {year})
                                  </span>
                                );
                              })()}
                            </Typography>
                            <Typography className="inv-hero-price-value">
                              {this.state.retailAmount
                                ? `$${this.state.retailAmount}`
                                : "---"}
                            </Typography>
                            </div>
                          </div>
                        )}
                        <div className="inv-hero-price-row">
                          <LocalOfferIcon className="inv-hero-price-icon" />
                          <div className="inv-hero-price-text">
                          <Typography className="inv-hero-price-label">
                            List Price
                          </Typography>
                          <Typography className="inv-hero-price-value">
                            {this.formatMoney(
                              this.state.inventoryDetailByIdDetails?.tag_price,
                            )}
                          </Typography>
                          </div>
                          </div>
                        </div>
                        <Dialog
                          open={this.state.open}
                          onClose={this.handleClose}
                          aria-labelledby="responsive-dialog-title"
                        >
                          <DialogContent style={{ paddingLeft: "0px" }}>
                            <DialogContentText>
                              <div style={{ marginLeft: "10px" }}>
                                <Typography variant="h6">
                                  <b>Watch Video {this.state.UploadPic9}</b>
                                </Typography>
                                <Grid container spacing={1}>
                                  <Grid item xs={6} sm={6} md={12} lg={12}>
                                    <div style={{ width: "580px" }}>
                                      {this.state?.inventoryDetailByIdDetails
                                        ?.imagepaths?.video && (
                                        <VideoPlayer
                                          videoUrl={
                                            this.state
                                              ?.inventoryDetailByIdDetails
                                              ?.imagepaths?.video +
                                            "?autoplay=1"
                                          }
                                          snapshotAt={10}
                                        />
                                      )}
                                    </div>
                                  </Grid>
                                </Grid>
                              </div>
                            </DialogContentText>
                          </DialogContent>
                          <DialogActions>
                            <Button
                              autoFocus
                              onClick={this.handleClose}
                              color="primary"
                            >
                              Close
                            </Button>
                          </DialogActions>
                        </Dialog>
                      </div>
                      <div className="inv-hero-actions">
                        {this.state.userData &&
                        (!this.state.userData?.planDetails ||
                          this.state.userData?.planDetails ===
                            "Noplan") ? null : (
                          <>
                            {this.state.inventoryDetailByIdDetails.sold === 1 &&
                              this.state.invoiceId &&
                              this.state.inventoryDetailByIdDetails.status !==
                                "Void" && (
                                <button
                                  type="button"
                                  className="inv-hero-btn"
                                  onClick={() =>
                                    this.setState({
                                      viewInvoiceModal: true,
                                      invoiceViewType: "regular",
                                    })
                                  }
                                >
                                  VIEW INVOICE
                                </button>
                              )}
                            {this.state.inventoryDetailByIdDetails.sold === 1 &&
                              this.state.inventoryDetailByIdDetails.status !==
                                "Void" &&
                              this.state.invoiceId && (
                                <div className="inv-sold-chip">
                                  <BookmarkAddedIcon
                                    style={{ fontSize: "17px" }}
                                  />
                                  Sold Price:{" "}
                                  {this.state.inventoryDetailByIdDetails
                                    .sold_price
                                    ? "$ " +
                                      this.state.inventoryDetailByIdDetails
                                        .sold_price
                                    : "--"}
                                </div>
                              )}
                            {this.state.inventoryDetailByIdDetails.sold == 0 &&
                              this.state.inventoryDetailByIdDetails?.memoid &&
                              this.state.inventoryDetailByIdDetails
                                .inventory_status == "3" && (
                                <button
                                  type="button"
                                  className="inv-hero-btn"
                                  onClick={() =>
                                    this.setState({
                                      viewInvoiceModal: true,
                                      invoiceViewType: "memo",
                                    })
                                  }
                                >
                                  VIEW MEMO INVOICE
                                </button>
                              )}
                            {isActionAllowed(
                              this.state.accessData,
                              "create_invoice",
                            ) &&
                              this.state.inventoryDetailByIdDetails.sold !==
                                1 &&
                              this.state.inventoryDetailByIdDetails.status !==
                                "Void" &&
                              this.state.inventoryDetailByIdDetails
                                ?.inventory_status != 3 && (
                                <button
                                  type="button"
                                  className="inv-hero-btn inv-hero-btn-main"
                                  onClick={this.handleOpenModal}
                                >
                                  {/* <ReceiptLongIcon className="inv-hero-btn-icon" /> */}
                                  CREATE INVOICE
                                </button>
                              )}
                          </>
                        )}
                        <div className="inv-hero-btn-row">
                          <button
                            type="button"
                            className="inv-hero-btn"
                            onClick={this.viewhistory}
                          >
                            <HistoryIcon className="inv-hero-btn-icon" />
                            VIEW HISTORY
                          </button>
                          {(isActionAllowed(
                            this.state.accessData,
                            "edit_inventory",
                          ) ||
                            (this.state.userData &&
                              this.state.userData.roleId === 10)) && (
                            <button
                              type="button"
                              className="inv-hero-btn"
                              onClick={this.editinvnetrydeatils}
                            >
                              <EditIcon className="inv-hero-btn-icon inv-hero-btn-icon-edit" />
                              EDIT
                            </button>
                          )}
                        </div>
                      </div>
                    <div className="inv-status-bar">
                      <div className="inv-status-item">
                        <span className="label">Inventory Status</span>
                        <span
                          className={this.getStatusBadgeClass(
                            this.state.inventoryDetailByIdDetails
                              ?.inventory_status,
                          )}
                        >
                          {this.state.inventoryDetailByIdDetails
                            ?.inventory_status
                            ? renderInventoryStatusLabel(
                                this.state.inventoryDetailByIdDetails
                                  .inventory_status,
                                InventoryStatusLookup,
                              )
                            : "---"}
                        </span>
                      </div>
                      <div className="inv-status-item">
                        <span className="label">Inventory Type</span>
                        <span className="value">
                          {this.getInventoryTypeLabel()}
                        </span>
                      </div>
                      <div className="inv-status-item">
                        <span className="label">Added On</span>
                        <span className="value">
                          {this.state.inventoryDetailByIdDetails?.createdon
                            ? formatDate(
                                this.state.inventoryDetailByIdDetails
                                  .createdon,
                                "MMM D, YYYY",
                              )
                            : "---"}
                        </span>
                      </div>
                      <div className="inv-status-item">
                        <span className="label">Condition</span>
                        <span className="value">
                          {this.getConditionLabel()}
                        </span>
                      </div>
                    </div>
                    </div>
                    </div>
                  </Card>
                </Container>

                {this.state.displaysharingImg ? (
                  <Container style={{ marginBottom: "10px" }}>
                    <div className="space-top-30">
                      <Typography
                        variant="h4"
                        className="font-size-24 color-232323 center-text"
                      >
                        <b>Select Images To Share</b>
                      </Typography>
                    </div>

                    <Grid container spacing={4}>
                      {this.state.inventoryDetailByIdDetails.imagepaths
                        .front ? (
                        <Grid item xs={6} sm={3} md={3}>
                          <div>
                            <div className="boxshodow">
                              <Typography variant="h5" className="boxtitle">
                                Front
                              </Typography>
                              <img
                                src={
                                  this.state.inventoryDetailByIdDetails &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths.front
                                }
                                alt="client-logo-1"
                                className="img-width-23 img-responsive2"
                                onClick={() => {
                                  this.onsocialsearch4(
                                    this.state.inventoryDetailByIdDetails
                                      .imagepaths.front,
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </Grid>
                      ) : (
                        ""
                      )}

                      {this.state.inventoryDetailByIdDetails.imagepaths.back ? (
                        <Grid item xs={6} sm={3} md={3}>
                          <div>
                            <div className="boxshodow">
                              <Typography variant="h5" className="boxtitle">
                                Back
                              </Typography>
                              <img
                                src={
                                  this.state.inventoryDetailByIdDetails &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths.back
                                }
                                alt="client-logo-1"
                                className="img-width-23 img-responsive2"
                                onClick={() => {
                                  this.onsocialsearch1(
                                    this.state.inventoryDetailByIdDetails
                                      .imagepaths.back,
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </Grid>
                      ) : (
                        ""
                      )}
                      {this.state.inventoryDetailByIdDetails.imagepaths
                        .right ? (
                        <Grid item xs={6} sm={3} md={3}>
                          <div>
                            <div className="boxshodow">
                              <Typography variant="h5" className="boxtitle">
                                Right
                              </Typography>
                              <img
                                src={
                                  this.state.inventoryDetailByIdDetails &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths.right
                                }
                                alt="client-logo-1"
                                className="img-width-23 img-responsive2"
                                onClick={() => {
                                  this.onsocialsearch6(
                                    this.state.inventoryDetailByIdDetails
                                      .imagepaths.right,
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </Grid>
                      ) : (
                        ""
                      )}

                      {this.state.inventoryDetailByIdDetails.imagepaths.left ? (
                        <Grid item xs={6} sm={3} md={3}>
                          <div>
                            <div className="boxshodow">
                              <Typography variant="h5" className="boxtitle">
                                left
                              </Typography>
                              <img
                                src={
                                  this.state.inventoryDetailByIdDetails &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths.left
                                }
                                alt="client-logo-1"
                                className="img-width-23 img-responsive2"
                                onClick={() => {
                                  this.onsocialsearch5(
                                    this.state.inventoryDetailByIdDetails
                                      .imagepaths.left,
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </Grid>
                      ) : (
                        ""
                      )}

                      {this.state.inventoryDetailByIdDetails.imagepaths.top ? (
                        <Grid item xs={6} sm={3} md={3}>
                          <div>
                            <div className="boxshodow">
                              <Typography variant="h5" className="boxtitle">
                                Top
                              </Typography>

                              <img
                                src={
                                  this.state.inventoryDetailByIdDetails &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths.top
                                }
                                alt="client-logo-1"
                                className="img-width-23 img-responsive2"
                                onClick={() => {
                                  this.onsocialsearch2(
                                    this.state.inventoryDetailByIdDetails
                                      .imagepaths.top,
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </Grid>
                      ) : (
                        ""
                      )}
                      {this.state.inventoryDetailByIdDetails.imagepaths
                        .bottom ? (
                        <Grid item xs={6} sm={3} md={3}>
                          <div>
                            <div className="boxshodow">
                              <Typography variant="h5" className="boxtitle">
                                Bottom
                              </Typography>

                              <img
                                src={
                                  this.state.inventoryDetailByIdDetails &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths.bottom
                                }
                                alt="client-logo-1"
                                className="img-width-23 img-responsive2"
                                onClick={() => {
                                  this.onsocialsearch3(
                                    this.state.inventoryDetailByIdDetails
                                      .imagepaths.bottom,
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </Grid>
                      ) : (
                        ""
                      )}
                      {this.state.inventoryDetailByIdDetails.imagepaths
                        .buckle_opened ? (
                        <Grid item xs={6} sm={3} md={3}>
                          <div>
                            <div className="boxshodow">
                              <Typography variant="h5" className="boxtitle">
                                Buckle Opened
                              </Typography>

                              <img
                                src={
                                  this.state.inventoryDetailByIdDetails &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths.buckle_opened
                                }
                                alt="client-logo-1"
                                className="img-width-23 img-responsive2"
                                onClick={() => {
                                  this.onsocialsearch7(
                                    this.state.inventoryDetailByIdDetails
                                      .imagepaths.buckle_opened,
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </Grid>
                      ) : (
                        ""
                      )}
                      {this.state.inventoryDetailByIdDetails.imagepaths
                        .buckle_closed ? (
                        <Grid item xs={6} sm={3} md={3}>
                          <div>
                            <div className="boxshodow">
                              <Typography variant="h5" className="boxtitle">
                                Buckle Closed
                              </Typography>
                              <img
                                src={
                                  this.state.inventoryDetailByIdDetails &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths.buckle_closed
                                }
                                alt="client-logo-1"
                                className="img-width-23 img-responsive2"
                                onClick={() => {
                                  this.onsocialsearch8(
                                    this.state.inventoryDetailByIdDetails
                                      .imagepaths.buckle_closed,
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </Grid>
                      ) : (
                        ""
                      )}
                    </Grid>
                  </Container>
                ) : (
                  <Container style={{ marginBottom: "10px" }}>
                      <div className="inv-detail-grid">
                        <div>
                          <Card
                            className="inv-info-card"
                            elevation={0}
                          >
                            <Typography className="inv-info-card-title">
                              Product Specifications
                            </Typography>
                          {!["misc_watch", "misc_product"].includes(
                            (
                              this.state.inventoryDetailByIdDetails?.type || ""
                            ).toLowerCase(),
                          ) && (
                          <div className="space-bottom-5 space-top-5 border-bottom-1">
                            <Grid container spacing={2}>
                              <Grid item xs={4} sm={4} md={4}>
                                <div>
                                    <Typography
                                      variant="p"
                                      component="p"
                                      className="color-00000061"
                                    >
                                      Last Updated MSRP
                                    </Typography>
                                  </div>
                              </Grid>
                              <Grid item xs={8} sm={8} md={8}>
                                  <div>
                                    <Typography
                                      variant="p"
                                      component="p"
                                      className="float-right"
                                    >
                                      <b>
                                        {this.state.retailAmount
                                          ? `$${this.state.retailAmount}`
                                          : "List Price Not Available"}
                                      </b>
                                    </Typography>
                                  </div>
                              </Grid>
                            </Grid>
                          </div>
                          )}
                          {!["misc_watch", "misc_product"].includes(
                            (
                              this.state.inventoryDetailByIdDetails?.type || ""
                            ).toLowerCase(),
                          ) && (
                            <>
                              <div className="space-bottom-5 space-top-5 border-bottom-1">
                                <Grid container spacing={2}>
                                  <Grid item xs={4} sm={4} md={4}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="color-00000061"
                                      >
                                        Purchase Range
                                      </Typography>
                                    </div>
                                  </Grid>
                                  <Grid item xs={8} sm={8} md={8}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="float-right"
                                      >
                                        <b>
                                          {(() => {
                                            const min = Number(
                                              this.state
                                                ?.inventoryDetailByIdDetails
                                                ?.minmax_pricelist
                                                ?.min_inventory_cost,
                                            );

                                            const max = Number(
                                              this.state
                                                ?.inventoryDetailByIdDetails
                                                ?.minmax_pricelist
                                                ?.max_inventory_cost,
                                            );

                                            const hasMin =
                                              this.state
                                                ?.inventoryDetailByIdDetails
                                                ?.minmax_pricelist
                                                ?.min_inventory_cost != null;

                                            const hasMax =
                                              this.state
                                                ?.inventoryDetailByIdDetails
                                                ?.minmax_pricelist
                                                ?.max_inventory_cost != null;

                                            if (
                                              !hasMin ||
                                              !hasMax ||
                                              (min === 0 && max === 0)
                                            ) {
                                              return "N/A";
                                            }
                                            if (min === 0) {
                                              return `$${max.toLocaleString()}`;
                                            }

                                            return `$${min.toLocaleString()} - $${max.toLocaleString()}`;
                                          })()}
                                        </b>
                                      </Typography>
                                    </div>
                                  </Grid>
                                </Grid>
                              </div>
                              <div className="space-bottom-5 space-top-5 border-bottom-1">
                                <Grid container spacing={2}>
                                  <Grid item xs={4} sm={4} md={4}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="color-00000061"
                                      >
                                        Selling Range
                                      </Typography>
                                    </div>
                                  </Grid>
                                  <Grid item xs={8} sm={8} md={8}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="float-right"
                                      >
                                        <b>
                                          {(() => {
                                            const min = Number(
                                              this.state
                                                ?.inventoryDetailByIdDetails
                                                ?.minmax_pricelist
                                                ?.min_invoice_cost,
                                            );

                                            const max = Number(
                                              this.state
                                                ?.inventoryDetailByIdDetails
                                                ?.minmax_pricelist
                                                ?.max_invoice_cost,
                                            );

                                            const hasMin =
                                              this.state
                                                ?.inventoryDetailByIdDetails
                                                ?.minmax_pricelist
                                                ?.min_invoice_cost != null;

                                            const hasMax =
                                              this.state
                                                ?.inventoryDetailByIdDetails
                                                ?.minmax_pricelist
                                                ?.max_invoice_cost != null;

                                            if (
                                              !hasMin ||
                                              !hasMax ||
                                              (min === 0 && max === 0)
                                            ) {
                                              return "N/A";
                                            }
                                            if (min === 0) {
                                              return `$${max.toLocaleString()}`;
                                            }

                                            return `$${min.toLocaleString()} - $${max.toLocaleString()}`;
                                          })()}
                                        </b>
                                      </Typography>
                                    </div>
                                  </Grid>
                                </Grid>
                              </div>
                            </>
                          )}
                          {/* <hr style={{ width: '330px' }} /> */}
                          {((this.state.inventoryDetailByIdDetails.type &&
                            this.state.inventoryDetailByIdDetails.type !==
                              "misc_watch" &&
                            this.state.inventoryDetailByIdDetails.type !==
                              "misc_product") ||
                            this.state.inventoryDetailByIdDetails.type ===
                              null) && (
                            <>
                              <div>
                                <div className="space-bottom-5 space-top-5 border-bottom-1">
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4} md={4}>
                                      <div>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="color-00000061"
                                        >
                                          Brand Name
                                        </Typography>
                                      </div>
                                    </Grid>
                                    <Grid item xs={8} sm={8} md={8}>
                                      <div>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="float-right"
                                        >
                                          <b>
                                            {this.state
                                              ?.inventoryDetailByIdDetails
                                              ?.brandname || "---"}
                                          </b>
                                        </Typography>
                                      </div>
                                    </Grid>
                                  </Grid>
                                </div>
                                <div className="space-bottom-5 space-top-5 border-bottom-1">
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4} md={4}>
                                      <div>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="color-00000061"
                                        >
                                          Model Number
                                        </Typography>
                                      </div>
                                    </Grid>
                                    <Grid item xs={8} sm={8} md={8}>
                                      <div>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="float-right"
                                        >
                                          <b>
                                            {this.state
                                              ?.inventoryDetailByIdDetails
                                              ?.invattr?.reference || "---"}
                                          </b>
                                        </Typography>
                                      </div>
                                    </Grid>
                                  </Grid>
                                </div>
                                <div className="space-bottom-5 space-top-5 border-bottom-1">
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4} md={4}>
                                      <div>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="color-00000061"
                                        >
                                          Model Name
                                        </Typography>
                                      </div>
                                    </Grid>
                                    <Grid item xs={8} sm={8} md={8}>
                                      <div>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="float-right"
                                        >
                                          <b>
                                            {this.state
                                              ?.inventoryDetailByIdDetails
                                              ?.invattr?.model || "---"}
                                          </b>
                                        </Typography>
                                      </div>
                                    </Grid>
                                  </Grid>
                                </div>
                                <div className="space-bottom-5 space-top-5 border-bottom-1">
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4} md={4}>
                                      <div>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="color-00000061"
                                        >
                                          Case Material
                                        </Typography>
                                      </div>
                                    </Grid>
                                    <Grid item xs={8} sm={8} md={8}>
                                      <div>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="float-right"
                                        >
                                          <b>
                                            {this.state
                                              ?.inventoryDetailByIdDetails
                                              ?.invattr?.casematerial || "---"}
                                          </b>
                                        </Typography>
                                      </div>
                                    </Grid>
                                  </Grid>
                                </div>
                                <div className="space-bottom-5 space-top-5 border-bottom-1">
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4} md={4}>
                                      <div>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="color-00000061"
                                        >
                                          Case Size
                                        </Typography>
                                      </div>
                                    </Grid>
                                    <Grid item xs={8} sm={8} md={8}>
                                      <div>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="float-right"
                                        >
                                          <b>
                                            {this.state
                                              ?.inventoryDetailByIdDetails
                                              ?.invattr?.casesize || "---"}
                                          </b>
                                        </Typography>
                                      </div>
                                    </Grid>
                                  </Grid>
                                </div>
                                <div className="space-bottom-5 space-top-5 border-bottom-1">
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4} md={4}>
                                      <div>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="color-00000061"
                                        >
                                          Dial Color
                                        </Typography>
                                      </div>
                                    </Grid>
                                    <Grid item xs={8} sm={8} md={8}>
                                      <div>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="float-right"
                                        >
                                          <b>
                                            {this.state
                                              ?.inventoryDetailByIdDetails
                                              ?.invattr?.dialcolor || "---"}
                                          </b>
                                        </Typography>
                                      </div>
                                    </Grid>
                                  </Grid>
                                </div>
                                <div className="space-bottom-5 space-top-5 border-bottom-1">
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4} md={4}>
                                      <div>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="color-00000061"
                                        >
                                          Band Type
                                        </Typography>
                                      </div>
                                    </Grid>
                                    <Grid item xs={8} sm={8} md={8}>
                                      <div>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="float-right"
                                        >
                                          <b>
                                            {this.state
                                              ?.inventoryDetailByIdDetails
                                              ?.invattr?.bandtype || "---"}
                                          </b>
                                        </Typography>
                                      </div>
                                    </Grid>
                                  </Grid>
                                </div>
                                <div className="space-bottom-5 space-top-5 border-bottom-1">
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4} md={4}>
                                      <div>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="color-00000061"
                                        >
                                          Band Material
                                        </Typography>
                                      </div>
                                    </Grid>
                                    <Grid item xs={8} sm={8} md={8}>
                                      <div>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="float-right"
                                        >
                                          <b>
                                            {this.state
                                              ?.inventoryDetailByIdDetails
                                              ?.invattr?.bandmaterial || "---"}
                                          </b>
                                        </Typography>
                                      </div>
                                    </Grid>
                                  </Grid>
                                </div>
                                <div className="inv-additional-details">
                                  <button
                                    type="button"
                                    className="inv-additional-details-toggle"
                                    onClick={() =>
                                      this.setState((prev) => ({
                                        additionalDetailsOpen:
                                          !prev.additionalDetailsOpen,
                                      }))
                                    }
                                  >
                                    <span>
                     {this.state.additionalDetailsOpen
                                        ? "Additional Details"
                                        : "View details"}
                                    </span>
                                    <ExpandMoreIcon
                                      className={`inv-additional-details-chevron ${
                                        this.state.additionalDetailsOpen
                                          ? "open"
                                          : ""
                                      }`}
                                    />
                                  </button>
                                  {this.state.additionalDetailsOpen && (
                                    <div className="inv-additional-details-body">
                                      {[
                                        {
                                          label: "Band Size",
                                          value:
                                            this.state
                                              ?.inventoryDetailByIdDetails
                                              ?.bandsize,
                                        },
                                    {
                                          label: "Caliber",
                                          value:
                                            this.state
                                              ?.inventoryDetailByIdDetails
                                              ?.invattr?.caliber,},
                                        {
                                          label: "Water Resistant",
                                          value:
                                            this.state
                                              ?.inventoryDetailByIdDetails
                                              ?.invattr?.waterresistant,
                                        },
                                        {
                                          label: "Index Type",
                                          value:
                                            this.state
                                              ?.inventoryDetailByIdDetails
                                              ?.invattr?.indices,
},
                                    {
                                          label: "Buckle Type",
                                          value:
                                            this.state
                                              ?.inventoryDetailByIdDetails
                                              ?.invattr?.buckletype,
                                        },
                                        {
                                          label: "Bezel",
                                          value:
                                            this.state
                                              ?.inventoryDetailByIdDetails
                                              ?.invattr?.bezel,
                                        },
                                        {
                                          label: "Band Color",
                                          value:
                                            this.state
                                              ?.inventoryDetailByIdDetails
                                              ?.invattr?.bandcolor,
                                        },
                                      ].map((row) => (
                                        <div
                                          className="space-bottom-5 space-top-5 border-bottom-1"
                                          key={row.label}
                                        >
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4} md={4}>
                                      <div>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="color-00000061"
                                        >
                                          {row.label}
                                        </Typography>
                                      </div>
                                    </Grid>
                                    <Grid item xs={8} sm={8} md={8}>
                                      <div>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="float-right"
                                        >
                                                            <b>{row.value || "---"}</b>
                                        </Typography>
                                      </div>
                                    </Grid>
                                  </Grid>
                                </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </>
                          )}

                          {this.state.inventoryDetailByIdDetails.type &&
                            this.state.inventoryDetailByIdDetails.type ===
                              "misc_watch" && (
                              <>
                                <div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={4} sm={4} md={4}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Product Name
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={8} sm={8} md={8}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                ?.inventoryDetailByIdDetails
                                                ?.technical_details
                                                ?.product_name || "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={4} sm={4} md={4}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Brand Name
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={8} sm={8} md={8}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                ?.inventoryDetailByIdDetails
                                                ?.technical_details
                                                ?.brand_name || "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={4} sm={4} md={4}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Model Number
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={8} sm={8} md={8}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                ?.inventoryDetailByIdDetails
                                                ?.technical_details
                                                ?.model_number || "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={4} sm={4} md={4}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Case Material
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={8} sm={8} md={8}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                ?.inventoryDetailByIdDetails
                                                ?.technical_details
                                                ?.case_material || "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={4} sm={4} md={4}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Case Size
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={8} sm={8} md={8}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                ?.inventoryDetailByIdDetails
                                                ?.technical_details
                                                ?.case_size || "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={4} sm={4} md={4}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Dial Color
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={8} sm={8} md={8}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                ?.inventoryDetailByIdDetails
                                                ?.technical_details
                                                ?.dial_color || "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={4} sm={4} md={4}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Band Material
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={8} sm={8} md={8}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                ?.inventoryDetailByIdDetails
                                                ?.technical_details
                                                ?.band_material || "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={4} sm={4} md={4}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Band Size
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={8} sm={8} md={8}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                ?.inventoryDetailByIdDetails
                                                ?.bandsize || "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                </div>
                              </>
                            )}
                          {this.state.inventoryDetailByIdDetails.type &&
                            this.state.inventoryDetailByIdDetails.type ===
                              "misc_product" && (
                              <>
                                <div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={4} sm={4} md={4}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Product Name
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={8} sm={8} md={8}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                ?.inventoryDetailByIdDetails
                                                ?.technical_details
                                                ?.product_name || "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={4} sm={4} md={4}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Product Category
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={8} sm={8} md={8}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right text-capitalize"
                                          >
                                            <b>
                                              {this.state
                                                ?.inventoryDetailByIdDetails
                                                ?.category || "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  {/* <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={4} sm={4} md={4}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Product Title
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={8} sm={8} md={8}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details.product_title
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details
                                                  .product_title
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div> */}
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={4} sm={4} md={4}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Description
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={8} sm={8} md={8}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                ?.inventoryDetailByIdDetails
                                                ?.technical_details
                                                ?.description || "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={4} sm={4} md={4}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Brand Name
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={8} sm={8} md={8}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                ?.inventoryDetailByIdDetails
                                                ?.technical_details
                                                ?.brand_name || "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={4} sm={4} md={4}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Model Number
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={8} sm={8} md={8}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                ?.inventoryDetailByIdDetails
                                                ?.technical_details
                                                ?.model_number || "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                </div>
                              </>
                            )}
                          </Card>
                        </div>
                        <div>
                          <Card className="inv-info-card" elevation={0}>
                            <Typography className="inv-info-card-title">
                              Inventory Details
                            </Typography>
                          {/* <hr style={{ width: '330px' }} /> */}
                          {/* {this.state.inventoryDetailByIdDetails.type !==
                            "misc_product" && ( */}
                            <>
                              <div className="space-bottom-5 space-top-5 border-bottom-1">
                                <Grid container spacing={2}>
                                  <Grid item xs={4} sm={4} md={4}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="color-00000061"
                                      >
                                        Inventory Title
                                      </Typography>
                                    </div>
                                  </Grid>
                                  <Grid item xs={8} sm={8} md={8}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="float-right"
                                      >
                                        <b>
                                          {(() => {
                                            const details =
                                              this.state?.inventoryDetailByIdDetails || {};
                                            const isMiscType = ["misc_watch", "misc_product"].includes(
                                              (details.type || "").toLowerCase(),
                                            );

                                            return isMiscType
                                              ? details.technical_details?.product_title ||
                                                details.product_title ||
                                                "---"
                                              : details.inventory_title ||
                                                details.technical_details?.product_title ||
                                                "---";
                                          })()}
                                        </b>
                                      </Typography>
                                    </div>
                                  </Grid>
                                </Grid>
                              </div>
                            </>
                          {/* // )} */}
                          <div className="space-bottom-5 space-top-5 border-bottom-1">
                            <Grid container spacing={2}>
                              <Grid item xs={4} sm={4} md={4}>
                                <div>
                                  <Typography
                                    variant="body2"
                                    component="p"
                                    className="color-00000061"
                                  >
                                    Serial Number
                                  </Typography>
                                </div>
                              </Grid>
                              <Grid item xs={8} sm={8} md={8}>
                                <div>
                                  <Typography
                                    variant="body2"
                                    component="p"
                                    align="right"
                                  >
                                    <b>
                                      {this.state.inventoryDetailByIdDetails
                                        .serialno
                                        ? this.state.inventoryDetailByIdDetails
                                            .serialno
                                        : "---"}
                                    </b>
                                  </Typography>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                          <div className="space-bottom-5 space-top-5 border-bottom-1">
                            <Grid container spacing={2}>
                              <Grid item xs={4} sm={4} md={4}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="color-00000061"
                                  >
                                    Inventory ID
                                  </Typography>
                                </div>
                              </Grid>
                              <Grid item xs={8} sm={8} md={8}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="float-right"
                                  >
                                    <b>
                                      {this.state.inventoryDetailByIdDetails
                                        .inventoryid
                                        ? this.state.inventoryDetailByIdDetails
                                            .inventoryid
                                        : "---"}
                                    </b>
                                  </Typography>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                          {this.state.inventoryDetailByIdDetails.type ===
                            "misc_product" && (
                            <div className="space-bottom-5 space-top-5 border-bottom-1">
                              <Grid container spacing={2}>
                                <Grid item xs={4} sm={4} md={4}>
                                  <div>
                                    <Typography
                                      variant="p"
                                      component="p"
                                      className="color-00000061"
                                    >
                                      Quantity
                                    </Typography>
                                  </div>
                                </Grid>
                                <Grid item xs={8} sm={8} md={8}>
                                  <div>
                                    <Typography
                                      variant="p"
                                      component="p"
                                      className="float-right"
                                    >
                                      <b>
                                        {this.state.inventoryDetailByIdDetails
                                          .quantity
                                          ? this.state
                                              .inventoryDetailByIdDetails
                                              .quantity
                                          : "---"}
                                      </b>
                                    </Typography>
                                  </div>
                                </Grid>
                              </Grid>
                            </div>
                          )}
                          {this.state.inventoryDetailByIdDetails
                            .inventorytype === "3" && (
                            <>
                              <div className="space-bottom-5 space-top-5 border-bottom-1">
                                <Grid container spacing={2}>
                                  <Grid item xs={4} sm={4} md={4}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="color-00000061"
                                      >
                                        Partnership Number
                                      </Typography>
                                    </div>
                                  </Grid>
                                  <Grid item xs={8} sm={8} md={8}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="float-right"
                                      >
                                        <b>
                                          {this.state.inventoryDetailByIdDetails
                                            .partnership_number || "---"}
                                        </b>
                                      </Typography>
                                    </div>
                                  </Grid>
                                </Grid>
                              </div>
                              <div className="space-bottom-5 space-top-5 border-bottom-1">
                                <Grid container spacing={2}>
                                  <Grid item xs={4} sm={4} md={4}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="color-00000061"
                                      >
                                        Partnership Details
                                      </Typography>
                                    </div>
                                  </Grid>
                                  <Grid item xs={8} sm={8} md={8}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="float-right"
                                      >
                                        <b>
                                          {this.state.inventoryDetailByIdDetails
                                            .partnershipdetais || "---"}
                                        </b>
                                      </Typography>
                                    </div>
                                  </Grid>
                                </Grid>
                              </div>
                            </>
                          )}
                          {this.state.inventoryDetailByIdDetails
                            .inventorytype === "2" && (
                            <>
                              <div className="space-bottom-5 space-top-5 border-bottom-1">
                                <Grid container spacing={2}>
                                  <Grid item xs={4} sm={4} md={4}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="color-00000061"
                                      >
                                        Memo Number
                                      </Typography>
                                    </div>
                                  </Grid>
                                  <Grid item xs={8} sm={8} md={8}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="float-right"
                                      >
                                        <b>
                                          {this.state.inventoryDetailByIdDetails
                                            .memo_number || "---"}
                                        </b>
                                      </Typography>
                                    </div>
                                  </Grid>
                                </Grid>
                              </div>
                              <div className="space-bottom-5 space-top-5 border-bottom-1">
                                <Grid container spacing={2}>
                                  <Grid item xs={4} sm={4} md={4}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="color-00000061"
                                      >
                                        Memo Details
                                      </Typography>
                                    </div>
                                  </Grid>
                                  <Grid item xs={8} sm={8} md={8}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="float-right"
                                      >
                                        <b>
                                          {this.state.inventoryDetailByIdDetails
                                            .memodetails || "---"}
                                        </b>
                                      </Typography>
                                    </div>
                                  </Grid>
                                </Grid>
                              </div>
                            </>
                          )}
                          {isActionAllowed(
                            this.state.viewData,
                            "purchase_from",
                          ) && (
                            <div className="space-bottom-5 space-top-5 border-bottom-1">
                              <Grid container spacing={2}>
                                <Grid item xs={4} sm={4} md={4}>
                                  <div>
                                    <Typography
                                      variant="p"
                                      component="p"
                                      className="color-00000061"
                                    >
                                      Purchase From
                                    </Typography>
                                  </div>
                                </Grid>
                                <Grid item xs={8} sm={8} md={8}>
                                  <div>
                                    <Typography
                                      variant="p"
                                      component="p"
                                      className="float-right"
                                    >
                                      <b>
                                        {this.state.inventoryDetailByIdDetails
                                          .purchasefrom
                                          ? this.state
                                              .inventoryDetailByIdDetails
                                              .purchasefrom
                                          : "---"}
                                      </b>
                                    </Typography>
                                  </div>
                                </Grid>
                              </Grid>
                            </div>
                          )}

                          {isActionAllowed(
                            this.state.viewData,
                            "purchase_price",
                          ) && (
                            <div className="space-bottom-5 space-top-5 border-bottom-1">
                              <Grid container spacing={2}>
                                <Grid item xs={4} sm={4} md={4}>
                                  <div>
                                    <Typography
                                      variant="p"
                                      component="p"
                                      className="color-00000061"
                                    >
                                      Purchase Price
                                    </Typography>
                                  </div>
                                </Grid>
                                <Grid item xs={8} sm={8} md={8}>
                                  <div>
                                    <Typography
                                      variant="p"
                                      component="p"
                                      className="float-right"
                                    >
                                      {this.state.inventoryDetailByIdDetails
                                        ?.purchaseinvoiceimages?.images
                                        ?.length > 0 && (
                                        <Tooltip title="Click to preview the Purchase invoice image">
                                          <IconButton
                                            size="small"
                                            onClick={this.handleOpenInvoice}
                                          >
                                            <DescriptionIcon
                                              fontSize="small"
                                              sx={{ color: "#1976d2" }}
                                            />
                                          </IconButton>
                                        </Tooltip>
                                      )}
                                      <b>
                                        {this.state.inventoryDetailByIdDetails
                                          ?.purchaseprice
                                          ? `$ ${this.state.inventoryDetailByIdDetails.purchaseprice}`
                                          : "---"}
                                      </b>
                                    </Typography>
                                  </div>
                                </Grid>
                              </Grid>
                            </div>
                          )}
                          <div className="space-bottom-5 space-top-5 border-bottom-1">
                            <Grid container spacing={2}>
                              <Grid item xs={4} sm={4} md={4}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="color-00000061"
                                  >
                                    Purchase Payment Status
                                  </Typography>
                                </div>
                              </Grid>
                              <Grid item xs={8} sm={8} md={8}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="float-right"
                                  >
                                    <b
                                      className={
                                        this.state.inventoryDetailByIdDetails
                                          .purchase_invoice_paid
                                          ? "inv-paid"
                                          : "inv-not-paid"
                                      }
                                    >
                                      {this.state.inventoryDetailByIdDetails
                                        .purchase_invoice_paid
                                        ? "Paid"
                                        : "Not Paid"}
                                    </b>
                                  </Typography>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                          {this.state.inventoryDetailByIdDetails
                            .purchase_invoice_paid ? (
                            <div className="space-bottom-5 space-top-5 border-bottom-1">
                              <Grid container spacing={2}>
                                <Grid item xs={4} sm={4} md={4}>
                                  <div>
                                    <Typography
                                      variant="p"
                                      component="p"
                                      className="color-00000061"
                                    >
                                      Purchase Payment Date
                                    </Typography>
                                  </div>
                                </Grid>
                                <Grid item xs={8} sm={8} md={8}>
                                  <div>
                                    <Typography
                                      variant="p"
                                      component="p"
                                      className="float-right"
                                    >
                                      <b>
                                        {this.state.inventoryDetailByIdDetails
                                          .purchase_payment_date
                                          ? // ? moment(this.state
                                            //   .inventoryDetailByIdDetails
                                            //   .purchase_payment_date).format('MM/DD/YYYY')
                                            formatDate(
                                              this.state
                                                .inventoryDetailByIdDetails
                                                .purchase_payment_date,
                                              "MM/DD/YYYY",
                                            )
                                          : "---"}
                                      </b>
                                    </Typography>
                                  </div>
                                </Grid>
                              </Grid>
                            </div>
                          ) : (
                            <div className="space-bottom-5 space-top-5 border-bottom-1">
                              <Grid container spacing={2}>
                                <Grid item xs={4} sm={4} md={4}>
                                  <div>
                                    <Typography
                                      variant="p"
                                      component="p"
                                      className="color-00000061"
                                    >
                                      Purchase Payment Due Date
                                    </Typography>
                                  </div>
                                </Grid>
                                <Grid item xs={8} sm={8} md={8}>
                                  <div>
                                    <Typography
                                      variant="p"
                                      component="p"
                                      className="float-right"
                                    >
                                      <b>
                                        {this.state.inventoryDetailByIdDetails
                                          .purchase_payment_duedate
                                          ? // ? moment(this.state
                                            //   .inventoryDetailByIdDetails
                                            //   .purchase_payment_duedate).format('MM/DD/YYYY')
                                            formatDate(
                                              this.state
                                                .inventoryDetailByIdDetails
                                                .purchase_payment_duedate,
                                              "MM/DD/YYYY",
                                            )
                                          : "---"}
                                      </b>
                                    </Typography>
                                  </div>
                                </Grid>
                              </Grid>
                            </div>
                          )}
                          <div className="space-bottom-5 space-top-5 border-bottom-1">
                            <Grid container spacing={2}>
                              <Grid item xs={4} sm={4} md={4}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="color-00000061"
                                  >
                                    Purchase Payment Details
                                  </Typography>
                                </div>
                              </Grid>
                              <Grid item xs={8} sm={8} md={8}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="float-right"
                                    style={{
                                      wordBreak: "break-word",
                                      whiteSpace: "normal",
                                      overflowWrap: "break-word",
                                      maxWidth: "100%",
                                    }}
                                  >
                                    <b>
                                      {this.state.inventoryDetailByIdDetails
                                        .purchase_payment_details
                                        ? this.state.inventoryDetailByIdDetails
                                            .purchase_payment_details
                                        : "---"}
                                    </b>
                                  </Typography>
                                </div>
                              </Grid>
                            </Grid>
                          </div>

                          {this.state.inventoryDetailByIdDetails.type !==
                            "misc_product" && (
                            <>
                              <div className="space-bottom-5 space-top-5 border-bottom-1">
                                <Grid container spacing={2}>
                                  <Grid item xs={4} sm={4} md={4}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="color-00000061"
                                      >
                                        Box
                                      </Typography>
                                    </div>
                                  </Grid>
                                  <Grid item xs={8} sm={8} md={8}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="float-right"
                                      >
                                        <b>
                                          {this.state.inventoryDetailByIdDetails
                                            .warrantybox &&
                                          this.state.inventoryDetailByIdDetails
                                            .warrantybox === "1"
                                            ? "Yes"
                                            : "No"}
                                        </b>
                                      </Typography>
                                    </div>
                                  </Grid>
                                </Grid>
                              </div>
                            </>
                          )}

                          {this.state.inventoryDetailByIdDetails.type !==
                            "misc_product" && (
                            <>
                              <div className="space-bottom-5 space-top-5 border-bottom-1">
                                <Grid container spacing={2}>
                                  <Grid item xs={4} sm={4} md={4}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="color-00000061"
                                      >
                                        Papers
                                      </Typography>
                                    </div>
                                  </Grid>
                                  <Grid item xs={8} sm={8} md={8}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="float-right"
                                        id={
                                          warrantypaper === "1"
                                            ? "warranty"
                                            : archive === 1
                                              ? "archive"
                                              : undefined
                                        }
                                      >
                                        <b>{this.getPapersYesNo()}</b>
                                      </Typography>
                                    </div>
                                  </Grid>
                                </Grid>
                              </div>
                            </>
                          )}

                          {this.state.inventoryDetailByIdDetails.type !==
                            "misc_product" &&
                            this.state.inventoryDetailByIdDetails
                              .warrantypaper === "1" && (
                              <>
                                <div
                                  className="space-bottom-5 space-top-5 border-bottom-1"
                                  id="warranty_date"
                                >
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4} md={4}>
                                      {this.state.inventoryDetailByIdDetails
                                        .warrantypaper === "1" && (
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Warranty Date
                                          </Typography>
                                        </div>
                                      )}
                                    </Grid>
                                    <Grid item xs={8} sm={8} md={8}>
                                      <div>
                                        {this.state.inventoryDetailByIdDetails
                                          .warrantypaper === "1" ? (
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails
                                                .warrantydate
                                                ? // ? moment(
                                                  //   this.state
                                                  //     .inventoryDetailByIdDetails
                                                  //     .warrantydate
                                                  // ).format("MM/DD/YYYY")
                                                  formatDate(
                                                    this.state
                                                      .inventoryDetailByIdDetails
                                                      .warrantydate,
                                                    "MM/DD/YYYY",
                                                  )
                                                : "No"}
                                            </b>
                                          </Typography>
                                        ) : (
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>{"---"}</b>
                                          </Typography>
                                        )}
                                      </div>
                                    </Grid>
                                  </Grid>
                                </div>
                              </>
                            )}

                          {this.state.inventoryDetailByIdDetails.type !==
                            "misc_product" &&
                            this.state.inventoryDetailByIdDetails.archive ===
                              1 && (
                              <>
                                <div
                                  className="space-bottom-5 space-top-5 border-bottom-1"
                                  id="archive_date"
                                >
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4} md={4}>
                                      {this.state.inventoryDetailByIdDetails
                                        .archive === 1 && (
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Archive Date
                                          </Typography>
                                        </div>
                                      )}
                                    </Grid>
                                    <Grid item xs={8} sm={8} md={8}>
                                      <div>
                                        {this.state.inventoryDetailByIdDetails
                                          .archive === 1 ? (
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails
                                                .archive_date
                                                ? // ? moment(
                                                  //   this.state
                                                  //     .inventoryDetailByIdDetails
                                                  //     .archive_date
                                                  // ).format("MM/DD/YYYY")
                                                  formatDate(
                                                    this.state
                                                      .inventoryDetailByIdDetails
                                                      .archive_date,
                                                    "MM/DD/YYYY",
                                                  )
                                                : "No"}
                                            </b>
                                          </Typography>
                                        ) : (
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>{"---"}</b>
                                          </Typography>
                                        )}
                                      </div>
                                    </Grid>
                                  </Grid>
                                </div>
                              </>
                            )}

                          {this.state.inventoryDetailByIdDetails.type !==
                            "misc_product" &&
                            this.state.inventoryDetailByIdDetails
                              .is_service && (
                              <>
                                <div
                                  className="space-bottom-5 space-top-5 border-bottom-1"
                                  id="service_date"
                                >
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4} md={4}>
                                      {this.state.inventoryDetailByIdDetails
                                        .is_service && (
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Service Date
                                          </Typography>
                                        </div>
                                      )}
                                    </Grid>
                                    <Grid item xs={8} sm={8} md={8}>
                                      <div>
                                        {this.state.inventoryDetailByIdDetails
                                          .is_service ? (
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails
                                                .service_date
                                                ? // ? moment(
                                                  //   this.state
                                                  //     .inventoryDetailByIdDetails
                                                  //     .service_date
                                                  // ).format("MM/DD/YYYY")
                                                  formatDate(
                                                    this.state
                                                      .inventoryDetailByIdDetails
                                                      .service_date,
                                                    "MM/DD/YYYY",
                                                  )
                                                : "No"}
                                            </b>
                                          </Typography>
                                        ) : (
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>{"---"}</b>
                                          </Typography>
                                        )}
                                      </div>
                                    </Grid>
                                  </Grid>
                                </div>
                              </>
                            )}
                          </Card>
                        </div>

                        <div>
                          <Card className="inv-info-card" elevation={0}>
                            <Typography className="inv-info-card-title">
                              Price & Notes
                            </Typography>
                          {isActionAllowed(
                            this.state.viewData,
                            "total_cost",
                          ) && (
                            <div className="space-bottom-5 space-top-5 border-bottom-1">
                              <Grid container spacing={2}>
                                <Grid item xs={4} sm={4} md={4}>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="color-00000061"
                                  >
                                    Total Cost
                                  </Typography>
                                </Grid>
                                <Grid item xs={8} sm={8} md={8}>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="float-right"
                                  >
                                    <b>
                                      {Number(
                                        this.state.inventoryDetailByIdDetails
                                          .total_cost,
                                      )
                                        ? `$ ${Number(this.state.inventoryDetailByIdDetails.total_cost)}`
                                        : "---"}
                                    </b>
                                  </Typography>
                                </Grid>
                              </Grid>
                            </div>
                          )}
                          <div className="space-bottom-5 space-top-5 border-bottom-1">
                            <Grid container spacing={2}>
                              <Grid item xs={4} sm={4} md={4}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="color-00000061"
                                  >
                                    {getCustomLabel("custom_wholesale_price", "Target Wholesale Price")}
                                  </Typography>
                                </div>
                              </Grid>
                              <Grid item xs={8} sm={8} md={8}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="float-right"
                                  >
                                    <b>
                                      {this.state.inventoryDetailByIdDetails
                                        ?.wholesaleprice
                                        ? `$ ${this.state.inventoryDetailByIdDetails.wholesaleprice}`
                                        : "---"}
                                    </b>
                                  </Typography>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                          <div className="space-bottom-5 space-top-5 border-bottom-1">
                            <Grid container spacing={2}>
                              <Grid item xs={4} sm={4} md={4}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="color-00000061"
                                  >
                                    {getCustomLabel("custom_end_customer_price", "Target End Customer Price")}
                                  </Typography>
                                </div>
                              </Grid>
                              <Grid item xs={8} sm={8} md={8}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="float-right"
                                  >
                                    <b>
                                      {this.state.inventoryDetailByIdDetails
                                        ?.retailprice
                                        ? `$ ${this.state.inventoryDetailByIdDetails.retailprice}`
                                        : "---"}
                                    </b>
                                  </Typography>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                          <div className="space-bottom-5 space-top-5 border-bottom-1">
                            <Grid container spacing={2}>
                              <Grid item xs={4} sm={4} md={4}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="color-00000061"
                                  >
                                    {getCustomLabel("custom_end_customer_wire_price", "Target End Customer Wire Price")}
                                  </Typography>
                                </div>
                              </Grid>
                              <Grid item xs={8} sm={8} md={8}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="float-right"
                                  >
                                    <b>
                                      {this.state.inventoryDetailByIdDetails
                                        ?.retailwireprice
                                        ? `$ ${this.state.inventoryDetailByIdDetails.retailwireprice}`
                                        : "---"}
                                    </b>
                                  </Typography>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                          <div className="space-bottom-5 space-top-5 border-bottom-1">
                            <Grid container spacing={2}>
                              <Grid item xs={4} sm={4} md={4}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="color-00000061"
                                  >
                                    {getCustomLabel("custom_tag_price", "Tag Price")}
                                  </Typography>
                                </div>
                              </Grid>
                              <Grid item xs={8} sm={8} md={8}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="float-right"
                                  >
                                    <b>
                                      {this.state.inventoryDetailByIdDetails
                                        .tag_price
                                        ? "$ " +
                                          this.state.inventoryDetailByIdDetails
                                            .tag_price
                                        : "---"}
                                    </b>
                                  </Typography>
                                </div>
                              </Grid>
                            </Grid>
                          </div>

                          <div className="space-bottom-5 space-top-5 border-bottom-1">
                            <Grid container spacing={2}>
                              <Grid item xs={4} sm={4} md={4}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="color-00000061"
                                  >
                                    Public Dealer Note
                                  </Typography>
                                </div>
                              </Grid>
                              <Grid item xs={8} sm={8} md={8}>
                                <div>
                                  <ClampedNoteValue
                                    text={
                                      this.state.inventoryDetailByIdDetails
                                        .public_dealer_note
                                    }
                                  />
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                          <div className="space-bottom-5 space-top-5 border-bottom-1">
                            <Grid container spacing={2}>
                              <Grid item xs={5} sm={4} md={3}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="color-00000061"
                                  >
                                    Private Dealer Note
                                  </Typography>
                                </div>
                              </Grid>
                              <Grid item xs={7} sm={8} md={9}>
                                <div>
                                  <ClampedNoteValue
                                    text={
                                      this.state.inventoryDetailByIdDetails
                                        .note
                                    }
                                  />
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                          {this.state.inventoryDetailByIdDetails.type !==
                            "misc_product" && (
                            <>
                              <div className="space-bottom-5 space-top-5 border-bottom-1">
                                <Grid container spacing={2}>
                                  <Grid item xs={4} sm={4} md={4}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="color-00000061"
                                      >
                                        Inventory Location
                                      </Typography>
                                    </div>
                                  </Grid>
                                  <Grid item xs={8} sm={8} md={8}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="float-right"
                                      >
                                        <b>
                                          {this.state.inventoryDetailByIdDetails
                                            .inventory_location
                                            ? this.state
                                                .inventoryDetailByIdDetails
                                                .inventory_location
                                            : "---"}
                                        </b>
                                      </Typography>
                                    </div>
                                  </Grid>
                                </Grid>
                              </div>

                              <div className="space-bottom-5 space-top-5 border-bottom-1">
                                <Grid container spacing={2}>
                                  <Grid item xs={5} sm={4} md={3}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="color-00000061"
                                      >
                                        Modified
                                      </Typography>
                                    </div>
                                  </Grid>
                                  <Grid item xs={7} sm={8} md={9}>
                                    <div>
                                      <Tooltip
                                        arrow
                                        title={
                                          this.state.inventoryDetailByIdDetails
                                            .ismodified === true && (
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails
                                                .modification_deatils
                                                ? this.state
                                                    .inventoryDetailByIdDetails
                                                    .modification_deatils
                                                : "- - -"}
                                            </b>
                                          )
                                        }
                                      >
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="float-right"
                                        >
                                          <b>
                                            {this.state
                                              .inventoryDetailByIdDetails
                                              .ismodified === true
                                              ? "Yes"
                                              : "No"}
                                          </b>
                                        </Typography>
                                      </Tooltip>
                                    </div>
                                  </Grid>
                                </Grid>
                              </div>
                            </>
                          )}
                          {this.state.isShopifyEnabled &&
                          this.state.isShopifyVerified ? (
                            <div className="space-bottom-5 space-top-5 border-bottom-1">
                              <Grid container spacing={2}>
                                <Grid item xs={5} sm={4} md={3}>
                                  <div>
                                    <Typography
                                      variant="p"
                                      component="p"
                                      className="color-00000061"
                                    >
                                      Include in Shopify
                                    </Typography>
                                  </div>
                                </Grid>
                                <Grid item xs={7} sm={8} md={9}>
                                  <div>
                                    <Tooltip
                                      arrow
                                      title={
                                        this.state.inventoryDetailByIdDetails
                                          .is_include_shopify === true && (
                                          <b>
                                            {this.state
                                              .inventoryDetailByIdDetails
                                              .is_include_shopify
                                              ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .is_include_shopify
                                              : "- - -"}
                                          </b>
                                        )
                                      }
                                    >
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="float-right"
                                      >
                                        <b>
                                          {this.state.inventoryDetailByIdDetails
                                            .is_include_shopify === true
                                            ? "Yes"
                                            : "No"}
                                        </b>
                                      </Typography>
                                    </Tooltip>
                                  </div>
                                </Grid>
                              </Grid>
                            </div>
                          ) : null}
                          {this.state.isQboVerified ? (
                            <div className="space-bottom-5 space-top-5 border-bottom-1">
                              <Grid container spacing={2}>
                                <Grid item xs={5} sm={4} md={3}>
                                  <div>
                                    <Typography
                                      variant="p"
                                      component="p"
                                      className="color-00000061"
                                    >
                                      Include in Quickbook
                                    </Typography>
                                  </div>
                                </Grid>
                                <Grid item xs={7} sm={8} md={9}>
                                  <div>
                                    <Typography
                                      variant="p"
                                      component="p"
                                      className="float-right"
                                    >
                                      <b>
                                        {this.state.inventoryDetailByIdDetails
                                          .qboitemid
                                          ? "Yes"
                                          : "No"}
                                      </b>
                                    </Typography>
                                  </div>
                                </Grid>
                              </Grid>
                            </div>
                          ) : null}
                          {this.state.isEbayVerified? (
                            <div className="space-bottom-5 space-top-5 border-bottom-1">
                              <Grid container spacing={2}>
                                <Grid item xs={5} sm={4} md={3}>
                                  <div>
                                    <Typography
                                      variant="p"
                                      component="p"
                                      className="color-00000061"
                                    >
                                      Include in Ebay
                                    </Typography>
                                  </div>
                                </Grid>
                                <Grid item xs={7} sm={8} md={9}>
                                  <div>
                                    <Typography
                                      variant="p"
                                      component="p"
                                      className="float-right"
                                    >
                                      <b>
                                        {this.state.inventoryDetailByIdDetails
                                          .is_addinventory_ebay && this.state.inventoryDetailByIdDetails
                            ?.ebay_listing_id
                                          ? "Yes"
                                          : "No"}
                                      </b>
                                    </Typography>
                                  </div>
                                </Grid>
                              </Grid>
                            </div>
                          ) : null}
                          {/* eBay URL row hidden; remove `false &&` to show it again */}
                          {false && this.state.inventoryDetailByIdDetails
                            ?.ebay_listing_id ? (
                            <div className="space-bottom-5 space-top-5 border-bottom-1">
                              <Grid container spacing={2}>
                                <Grid item xs={5} sm={4} md={3}>
                                  <div>
                                    <Typography
                                      variant="p"
                                      component="p"
                                      className="color-00000061"
                                    >
                                      Ebay URL
                                    </Typography>
                                  </div>
                                </Grid>
                                {/* <Grid item xs={7} sm={8} md={9}>
                                  <div>
                                    <Typography
                                      variant="p"
                                      component="p"
                                      className="float-right"
                                    >
                                      <a
                                        href={`https://www.ebay.com/itm/${this.state.inventoryDetailByIdDetails.ebay_listing_id}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          color: "#c29156",
                                          textDecoration: "underline",
                                          wordBreak: "break-all",
                                        }}
                                      >
                                        {`https://www.ebay.com/itm/${this.state.inventoryDetailByIdDetails.ebay_listing_id}`}
                                      </a>
                                    </Typography>
                                  </div>
                                </Grid> */}
                              </Grid>
                            </div>
                          ) : null}
                          {this.state.openHistoryModal && (
                            <Dialog
                              open={this.state.openHistoryModal}
                              onClose={this.handleCloseHistory}
                              fullWidth
                              maxWidth="md"
                            >
                              <DialogContent dividers>
                                <InventoryAuditLogsComponent
                                  inventoryId={this.state.inventory_id}
                                />
                              </DialogContent>
                              <DialogActions>
                                <Button
                                  onClick={this.handleCloseHistory}
                                  color="primary"
                                >
                                  Close
                                </Button>
                              </DialogActions>
                            </Dialog>
                          )}
                          {this.state.viewInvoiceModal && (
                            <ViewInvoicemodel
                              open={this.state.viewInvoiceModal}
                              handleClose={this.handleClosecheck}
                              invoiceid={{
                                id: this.state.invoiceId,
                                memoid:
                                  this.state.invoiceViewType === "memo"
                                    ? this.state.inventoryDetailByIdDetails
                                        ?.memoid
                                    : null,
                                memonumber: this.state.invoiceId
                                  ? null
                                  : this.state.inventoryDetailByIdDetails
                                      ?.memo_number,
                              }}
                            />
                          )}

                          {openModal && (
                            <Modal
                              open={openModal}
                              onClose={this.handleCloseModal}
                              aria-labelledby="modal-modal-title"
                            >
                              <Box sx={style}>
                                <Typography
                                  id="modal-modal-title"
                                  variant="h6"
                                  component="h2"
                                >
                                  Invoice Type
                                </Typography>
                                <FormControl fullWidth>
                                  <Select
                                    labelId="demo-simple-select-outlined-label"
                                    id="demo-simple-select-outlined"
                                    onChange={(e) =>
                                      this.setState({
                                        invoiceType: e.target.value,
                                      })
                                    }
                                    defaultValue={invoiceType}
                                    label="Payment Status"
                                  >
                                    <MenuItem value="regular_invoice">
                                      Regular Invoice
                                    </MenuItem>
                                    <MenuItem value="memo_invoice">
                                      Memo Invoice
                                    </MenuItem>
                                  </Select>
                                </FormControl>
                                <Box
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <Button
                                    type="submit"
                                    variant="text"
                                    style={{
                                      background: "#000",
                                      color: "#fff",
                                      marginTop: "20px",
                                      marginRight: "10px",
                                    }}
                                    onClick={() => {
                                      const invoiceDetails =
                                        this.getInvoiceDetails(
                                          this.state.inventoryDetailByIdDetails,
                                        );
                                      const path =
                                        invoiceType === "regular_invoice"
                                          ? "/create/invoice"
                                          : "/create/memoinvoice";
                                      this.props.history.push({
                                        pathname: path,
                                        state: {
                                          inventoryDetails: invoiceDetails,
                                        },
                                      });
                                    }}
                                  >
                                    Create
                                  </Button>
                                  &nbsp;
                                  <Button
                                    variant="outlined"
                                    onClick={this.handleCloseModal}
                                    style={{
                                      background: "#fff",
                                      color: "#000",
                                      marginTop: "20px",
                                      paddingTop: "5 !important",
                                      paddingBottom: "5 !important",
                                    }}
                                  >
                                    Cancel
                                  </Button>
                                </Box>
                              </Box>
                            </Modal>
                          )}
                          </Card>
                        </div>
                      </div>
                      {this.renderComments()}
                  </Container>
                )}
              </div>
            </div>
          )}
        </div>
      );
    }
  }
  render() {
    localStorage.setItem("menuTitle", "");
    return (
      <>
        {" "}
        <NewContentWrapper contentView={this.newContentView()} />
        <Dialog
          open={this.state.openInvoiceModal}
          onClose={this.handleCloseInvoice}
          maxWidth="md"
          fullWidth
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 3,
              pt: 2,
              pb: 0,
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Purchase Invoice Preview
            </Typography>
            <IconButton onClick={this.handleCloseInvoice}>
              <CloseIcon />
            </IconButton>
          </Box>
          <DialogContent>
            <Grid container spacing={2}>
              {this.state.inventoryDetailByIdDetails?.purchaseinvoiceimages?.images?.map(
                (img, index) => {
                  const isPDF = img.toLowerCase().includes(".pdf");
                  // ADDED: detect doc/docx
                  const isDoc = img.toLowerCase().includes(".doc");
                  const isDocx = img.toLowerCase().includes(".docx");
                  const isWord = isDoc || isDocx;

                  return (
                    <Grid item xs={12} key={index}>
                      {isPDF ? (
                        <iframe
                          src={`https://docs.google.com/viewer?url=${encodeURIComponent(img)}&embedded=true`}
                          width="100%"
                          height="500px"
                          title={`invoice-pdf-${index}`}
                          style={{ border: "none", borderRadius: "5px" }}
                        />
                      ) : isWord ? (
                        this.state.wordLoadingMap[index] ? (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: 200,
                            }}
                          >
                            <SpinnerRoundFilled size={50} color="#CEA05F" />
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              height: "500px",
                              overflowY: "auto",
                              border: "1px solid #e0e0e0",
                              borderRadius: "5px",
                              padding: "24px",
                              background: "#fff",
                              fontSize: "14px",
                              lineHeight: 1.7,
                              color: "#000",
                            }}
                            dangerouslySetInnerHTML={{
                              __html:
                                this.state.wordHtmlMap[index] ||
                                "<p style='color:#999'>Loading document...</p>",
                            }}
                          />
                        )
                      ) : (
                        <img
                          src={img}
                          alt={`invoice-${index}`}
                          style={{ width: "100%", borderRadius: "5px" }}
                        />
                      )}
                    </Grid>
                  );
                },
              )}
            </Grid>
          </DialogContent>
        </Dialog>
      </>
    );
  }
}
function mapStateToProps({ inventoryDetailByIdInfo }) {
  return {
    // inventoryDetailByIdInfo: inventoryDetailByIdInfo.inventoryDetailByIdInfo
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      inventoryDetailById,
    },
    dispatch,
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(InventoryDetailComponent);
